import React, { Component, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useLanguage, LanguageContext } from '../../../../context/LanguageContext';
/** Material UI Components * */
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import { withStyles } from '@material-ui/core';
import { FormControlLabel, RadioGroup } from '@material-ui/core';
import CustomFab from '../../../../components/FAB';
import CombinedFab from '../../../../components/CombinedFAB';
import AddIcon from '@material-ui/icons/Add';
import { createDateFromDateString } from '../../../../utilities/helpers';
import AlertDialog from '../../../../components/AlertDialog';
import ImportPreferencesDialog from '../../../../components/ImportPreferencesDIalog/ImportPreferencesDialog';
import { DefaultButton, RadioButton } from '../../../../components/Buttons';
import { DefaultCheckbox } from '../../../../components/Checkbox';
import { DefaultTextField } from '../../../../components/TextFields';
import * as actions from './../../../../data/bidClasses/actions';
import { getBidMode, saveBidMode, BidMode } from '../../helpers';
import * as bidSessionActions from './../../../../data/bidSession/actions';
import * as opentimesearchactions from './../../../../data/openTimeSearch/actions';
import {
  PROPERTIES,
  COMPONENTS,
  KINDOFBID,
  httpStatus,
  VALID_RELATIONS,
  LINE_CREDITS_ID,
  LAST_BID_SCOPE_USE,
  UNKNOWN_ATTRIBUTE_ID
} from './../../../../data/constants';
import BidClasses from './../BidClasses';
import Requests from './../Requests';
import CombinedPreferencesWindow from './../CombinedPreferencesWindow';
import ReserveLine from '../ReserveLine/ReserveLine';
import {
  DOW,
  FLYTEXTFIELD,
  LISTABLEDATE,
  MULTISELECT,
  TIME,
  WEIGHT,
  WEIGHTMODE,
  LADDERMODE,
  RESERVEDOWNTO
} from './../../../../data/constants/components';
import { DurationInterval } from './../../../../components/AddBid/components';
import CardHead from './../../../../components/CardHead';
import Notification from './../../../../components/Notification';
import CircularLoading from '../../../../components/CircularLoading';
import {
  getActionBidMessage,
  getParameterIndexWithRelations,
  getParameterRelation,
  getParameterValue,
  limitToOneBidPerGroup,
  hasEmptyValue,
  deepFreeze,
  deepClone,
  validateDifferentValue
} from './helpers';
import * as utils from '../../../../utilities/calendarUtilities';
import apiCall from '../../../../data/app/apiCall';
import { RESERVE_BID_SCOPE, REGULAR_BID_SCOPE, BID_TYPES, RESERVE_DOWN_TO } from '../../../../data/constants';

import './styles.scss';

const CancelBackBtn = ({ className = '', ...props }) => (
  <DefaultButton
    className={`cancel-back-btn ${className}`}
    {...props}
  />
);

const SaveApplyNextBtn = ({ className = '', ...props }) => (
  <DefaultButton
    className={`save-apply-next-btn ${className}`}
    {...props}
  />
);

const DefaultRadioGroup = withStyles({
  root: {
    display: 'flex',
    width: '100%',
    flexDirection: 'row',
    flexWrap: 'nowrap'
  }
})(RadioGroup);

const CombinedPreferencesTextField = withStyles({
  root: {
    width: '70%',
  }
})(DefaultTextField);

class BidTable extends Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    const initialState = this.buildDefaultState();
    const isToggled = BidMode.MANUAL.biddingMode === props.bidSession.bidMode;
    const lastUsedBidScope = sessionStorage.getItem(LAST_BID_SCOPE_USE);
    this.state = {
      ...initialState,
      hasBidSessionRequests: false,
      toggled: isToggled,
      bidMode: props.bidSession.bidMode,
      toggleScope: isToggled,
      toggleReserved: false,
      optionLevel: null,
      reserveLineList: props.bidSession && props.bidSession.reserveLine ? props.bidSession.reserveLine.bidderReserveLines : null,
      bidScope: lastUsedBidScope ? lastUsedBidScope : REGULAR_BID_SCOPE,
      changeBidScopeConfirmation: false,
      optionPropertyId: 0,
      filteredBidPreferences: {},
      configureReserveLineType: props.configureReserveLineType,
      displayCombinedPreferences: false
    };
    this._isCheckingBidSessionRequests = false;
    this.optionOnlyHasUnknown = null;
    this.durationHours = [];
    this.durationMinutes = [];
    this.durationFlag = false;
    this.hiddenParameters = [];
    this.errorMessages = null;
    this.handleScene = this.handleScene.bind(this);
  }

  componentDidMount() {
    // Attach checkBidSessionRequests to ref if provided
    if (this.props.forwardedRef) {
      this.props.forwardedRef.current = {
        checkBidSessionRequests: this.checkBidSessionRequests
      };
    }
    const bidOptionPropertyValue = this.getBidOptionPropertyValue(this.state.bidScope);
    this.setState({ optionPropertyId: bidOptionPropertyValue })
    this.filterPreferences(bidOptionPropertyValue);
    apiCall('preferences/displayEnabled?feature=combined').then(res => {
      this.setState({ displayCombinedPreferences: res.data })
    });
    this.checkBidSessionRequests();
  }
  componentWillUnmount() {
    if (this.props.forwardedRef) {
      this.props.forwardedRef.current = null;
    }
    // Clean up timeout to prevent memory leaks
    if (this.dateClearTimeout) {
      clearTimeout(this.dateClearTimeout);
      this.dateClearTimeout = null;
    }
    this.clearAllErrorsFromDOM();
  }

  checkBidSessionRequests = () => {
    if (this._isCheckingBidSessionRequests) return;
    this._isCheckingBidSessionRequests = true;
    const { bidSession } = this.props;
    const staffId = bidSession?.user?.staffId;
    const bidSessionId = bidSession?.currentBid?.bidSessionId;
    if (!staffId || !bidSessionId) {
      this._isCheckingBidSessionRequests = false;
      return;
    }
    apiCall(`preferences/hasRequests?staff_id=${encodeURIComponent(staffId)}&bidsession_id=${bidSessionId}`)
      .then(res => {
        this.setState({ hasBidSessionRequests: res.data === true });
      })
      .catch(() => {
        this.setState({ hasBidSessionRequests: false });
      })
      .finally(() => {
        this._isCheckingBidSessionRequests = false;
      });
  }

  // eslint-disable-next-line react/sort-comp
  buildDefaultState() {
    return {
      open: false,
      openCombinedPreferences: false,
      hasBidSessionRequests: false,
      justDeletedAll: false, // Flag to prevent race conditions after delete all
      selectedRBOption: true,
      modalScene: 1,
      targetParameter: 0,
      statusDisplay: false,
      statusDisplayText: '',
      fetchedStatus: false,
      deleteConfirmation: false,
      deleteAllConfirmation: false,
      changeWeightConfirmation: false,
      delBidId: 0,
      delEmployeeBidId: 0,
      editPreference: {},
      dialogNextState: true,
      classOption: null,
      slideIndex: 0,
      kindofBid: '',
      secondDate: '',
      secondDateUpdated: '',
      disabledSecondDate: false,
      scrollTop: 0,
      requestType: null,
      wish: true,
      maxnn: null,
      selectedRelation: '',
      selectedParameterValues: [],
      durationTime: 0,
      betweenDuration: true,
      betweenFirstTime: true,
      commentopen: false,
      comment: '',
      adminName: '',
      commentok: true,
      pairingvalue: '',
      weight: '',
      bidModeSwitched: false,
      openReserveLine: false,
      combinedPreferences: [],
      groupIndex: 0,
      bidSequence: null,
      combinedPreferencesName: '',
      deleteCombinedPreferenceName: '',
      combinedPreferencesScore: 0,
      errorCombined: false,
      employeeBidId: null,
      editPrefFromCombinedPreferenceClassId: null,
      groupIndexToModify: null,
      bidSequenceToModify: null,
      editPrefFromCombinedPreferenceOptionId: null,
      combinedDialogNextState: false,
      disableCancel: true,
      editCombinedPreferencesScore: null,
      copyOfEditCombinedPreferences: {},
      isAddButtonDisabled: false,
      preferenceOptionIdToDisableAddButton: null,
      datesClearedForPairing: false, // Track if we just cleared dates due to pairing change
      allDateValues: {},
      dateErrors: {},
      dateErrorMessages: {}, // Store error messages for each date field
    };
  }

  computeAndSaveBidMode() {
    const { bidSession } = this.props;
    const computedBidMode = this.computeBidMode();
    saveBidMode(computedBidMode);
    this.setState({ toggled: BidMode.MANUAL.biddingMode === computedBidMode });
    this.setState({ bidMode: computedBidMode });
    const updatedSession = this.buildUpdatedSession(
      bidSession,
      computedBidMode
    );
    this.props.updateBidSession(updatedSession);
  }

  buildUpdatedSession(bidSession, bidMode, score) {
    const entries = [];
    bidSession?.bidPreferences?.entries?.forEach(preference => {
      const changedScore = score !== undefined ? score : preference.score;
      const item = {
        ...preference,
        bidMode,
        score: changedScore
      };
      entries.push(item);
    });
    const bidPreferences = bidSession.bidPreferences;
    const updatedBidPreferences = {
      ...bidPreferences,
      entries
    };
    const updatedSession = {
      ...bidSession,
      bidPreferences: updatedBidPreferences,
      bidMode
    };
    return updatedSession;
  }

  computeBidMode() {
    const { bidSession } = this.props;
    const bidSessionBidMode = bidSession.bidMode;
    if (!this.isWeightMode(bidSessionBidMode)) {
      return bidSessionBidMode;
    }

    if (this.isBidSessionWithEmptyPreferences(bidSession)) {
      return bidSessionBidMode;
    }
    const firstPreferenceBidMode = bidSession.bidPreferences.entries[0].bidMode;
    if (BidMode.NONE.biddingMode === firstPreferenceBidMode) {
      return bidSessionBidMode;
    }
    return firstPreferenceBidMode;
  }

  isBidSessionWithEmptyPreferences(bidSession) {
    return (
      bidSession.bidPreferences === undefined ||
      bidSession.bidPreferences.entries === undefined ||
      bidSession.bidPreferences.entries.length === 0
    );
  }

  isWeightMode(bidMode) {
    return (
      BidMode.MANUAL.biddingMode === bidMode ||
      BidMode.AUTOMATIC.biddingMode === bidMode
    );
  }

  getActive(advanced) {
    const classNameNotActive = 'disabled';
    if (!this.isWeightMode(this.props.bidSession.bidMode)) {
      return classNameNotActive;
    }
    const classNameActive = 'active';
    if (advanced && this.state.toggled) {
      return classNameActive;
    }
    if (!advanced && !this.state.toggled) {
      return classNameActive;
    }
    return classNameNotActive;
  }

  isSelectedPairingDateAtIndexInvalid = (index) => {
    if (!this.props.pairingdate || !this.props.pairingdate.pairingdate || !this.state.selectedParameterValues[index]) {
      return true;
    }
    return !this.props.pairingdate.pairingdate.includes(this.state.selectedParameterValues[index].value);
  }

  areSelectedPairingDatesInvalid = (preferenceOptionId) => {
    if (preferenceOptionId !== KINDOFBID.PAIRING_START_ON_DATE && preferenceOptionId !== KINDOFBID.SPECIFIC_PAIRING_ON_DATES && preferenceOptionId !== KINDOFBID.SPECIFIC_PAIRING_STARTING_ON_DATES) {
      return false;
    }
    if (!this.state.selectedParameterValues || !this.state.selectedParameterValues[0] || !this.state.selectedParameterValues[1]) {
      return true;
    }
    if ((preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_ON_DATES || preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_STARTING_ON_DATES) && !this.state.selectedParameterValues[2]) {
      return true;
    }
    return preferenceOptionId === KINDOFBID.PAIRING_START_ON_DATE ?
      this.isSelectedPairingDateAtIndexInvalid(1) :
      (this.isSelectedPairingDateAtIndexInvalid(1) || this.isSelectedPairingDateAtIndexInvalid(2));
  }

  isEditingCombinedPreference = () => {
    return this.state.openCombinedPreferences &&
      this.state.groupIndexToModify !== null &&
      this.state.bidSequenceToModify !== null;
  }

  getCombinedPreferenceBid = () => {
    return this.state.combinedPreferences[this.state.groupIndexToModify]?.preferences.find(
      preference => preference.bidSequence === this.state.bidSequenceToModify
    );
  }

  getRelationFromBid = (bid, parameters, parameterIndexWithRelations) => {
    if (!bid?.parameterValues || parameterIndexWithRelations < 0) {
      return null;
    }

    const parameterWithRelation = bid.parameterValues.find(
      param => param.parameterId === parameters[parameterIndexWithRelations].parameterId
    );

    return parameterWithRelation?.parameterRelation || parameters[parameterIndexWithRelations].validRelations[0];
  }

  async UNSAFE_componentWillReceiveProps(nextProps, nextState) {
    // Get labels from context with fallbacks
    const { labels } = this.context || {};
    const BID_TABLE_CONTEXT = this.props.labels?.BID_TABLE || labels?.BID_TABLE;
    const isToggled =
      BidMode.MANUAL.biddingMode === nextProps.bidSession.bidMode;
    this.setState({ toggled: isToggled });
    let parameterIndexWithRelations = -1;
    let selectedRelation = '';
    this.setState({ reserveLineList: nextProps.bidSession && nextProps.bidSession.reserveLine ? nextProps.bidSession.reserveLine.bidderReserveLines : null })
    // If one of the bid options has a defaultValue = null,
    // we disable the Save button

    if (nextProps.bidPreferenceClasses.classOptionAttributes) {
      const classOptionAttributes =
        Object.keys(nextProps.bidPreferenceClasses.classOptionAttributes)
          .length > 0
          ? nextProps.bidPreferenceClasses.classOptionAttributes
          : {};
      const parameters = classOptionAttributes.parameters;
      if (parameters) {
        const selectedParameterValues = this.state.selectedParameterValues.length > 0 ? this.state.selectedParameterValues : parameters.map(
          parameter => parameter.defaultValue
        );
        parameterIndexWithRelations =
          getParameterIndexWithRelations(parameters);

        /*
        In a new request with the Relation selector, default selected relation will be
        the first valid relation of the parameter with multiple relations
        */
        if (parameterIndexWithRelations >= 0) {
          const isEditingCombined = this.isEditingCombinedPreference();
          if (isEditingCombined) {
            const bid = this.getCombinedPreferenceBid();
            selectedRelation = this.getRelationFromBid(bid, parameters, parameterIndexWithRelations) ||
              this.state.selectedRelation ||
              parameters[parameterIndexWithRelations].validRelations[0];
          } else {
            selectedRelation = parameters[parameterIndexWithRelations].validRelations[0];
          }
        }
        /*
          Next is an exception, when the option contains just one attribute
          and this attribute is an "unknown", we must enable the Save button
          inmediatly.
        */
        const firstAttrName = parameters[0].attribute.name.toUpperCase();
        const firstAttrIsUnknown =
          firstAttrName === BID_TABLE_CONTEXT.bidParameters.UNKNOWN;
        this.optionOnlyHasUnknown =
          firstAttrIsUnknown && parameters.length === 1;
        let dialogNextState;
        if (nextProps.bidPreferenceClasses.classOptionAttributes?.preferenceOptionId !== KINDOFBID.PAIRING_START_ON_DATE &&
          nextProps.bidPreferenceClasses.classOptionAttributes?.preferenceOptionId !== KINDOFBID.SPECIFIC_PAIRING_ON_DATES &&
          nextProps.bidPreferenceClasses.classOptionAttributes?.preferenceOptionId !== KINDOFBID.SPECIFIC_PAIRING_STARTING_ON_DATES) {
          dialogNextState = this.optionOnlyHasUnknown
            ? false
            : selectedParameterValues.includes(null);
          this.setState({
            dialogNextState,
            selectedRelation,
            selectedParameterValues
          });
        } else {
          dialogNextState = false;
          let parameterId;
          if (this.state.selectedParameterValues && this.state.selectedParameterValues[0]) {
            parameterId = this.state.selectedParameterValues[0]?.parameterId;
          }
          selectedParameterValues[0] = {
            value: this.state.selectedParameterValues[0]?.value || this.state.pairingvalue,
            parameterId
          };

          this.setState({
            dialogNextState,
            selectedRelation,
            selectedParameterValues
          });
        }

      }

    }

    // When editing, add the value of the component to selectedParameterValues
    if (
      this.state.editPreference &&
      Object.keys(this.state.editPreference).length > 0 &&
      !Array.isArray(this.state.editPreference) &&
      !this.state.openCombinedPreferences
    ) {
      const selectedParameterValues = [];

      // For pairing bids, check if we have current selectedParameterValues that should be preserved
      const isPairingBidWithDates = (nextProps.bidPreferenceClasses.classOptionAttributes?.preferenceOptionId === KINDOFBID.PAIRING_START_ON_DATE ||
        nextProps.bidPreferenceClasses.classOptionAttributes?.preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_ON_DATES ||
        nextProps.bidPreferenceClasses.classOptionAttributes?.preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_STARTING_ON_DATES);

      if (isPairingBidWithDates && this.state.selectedParameterValues.length > 0) {
        // Use current selectedParameterValues instead of restoring from editPreference
        // This preserves any cleared date values
        this.state.selectedParameterValues.forEach(parameter => {
          if (parameter) {
            selectedParameterValues.push({
              value: parameter.value,
              parameterId: parameter.parameterId
            });
          }
        });
      } else {
        // For non-pairing bids or when no current values exist, use editPreference values
        this.state.editPreference.parameterValues.forEach(parameter => {
          const param = {
            value: parameter.value,
            parameterId: parameter.parameterId
          };
          selectedParameterValues.push(param);
        });
      }

      /*
      When editing a request with the Relation selector, default selected relation will be
      the parameterRelation previously saved for the parameter with multiple relations
      */
      if (parameterIndexWithRelations >= 0) {
        selectedRelation =
          this.state.editPreference.parameterValues[parameterIndexWithRelations]
            .parameterRelation;
      }
      if (isPairingBidWithDates) {

        const dialogNextState = this.areSelectedPairingDatesInvalid(nextProps.bidPreferenceClasses.classOptionAttributes.preferenceOptionId);
        if (this.state.selectedParameterValues && this.state.selectedParameterValues[0] && this.state.selectedParameterValues[0].parameterId) {
          selectedParameterValues[0].parameterId = this.state.selectedParameterValues[0].parameterId;
        }
        selectedParameterValues[0].value = this.state.pairingvalue;

        const pairingvalue = this.state.editPreference.parameterValues[0].value;

        // Check if dates were just cleared for pairing - if so, don't restore old date values
        if (this.state.datesClearedForPairing) {
          // Only restore the pairing value, keep date fields empty
          for (let i = 1; i < selectedParameterValues.length; i++) {
            if (selectedParameterValues[i] && i !== 8) {
              selectedParameterValues[i].value = "";
            }
          }
        }

        if (!this.state.pairingvalue) {
          this.setState({ pairingvalue })
          this.handledateselect(pairingvalue, nextProps.bidPreferenceClasses.classOptionAttributes.preferenceOptionId);
        }
        this.setState({
          dialogNextState,
          selectedRelation,
          selectedParameterValues
        });
      }

      else {
        this.setState({
          dialogNextState: selectedParameterValues.includes(null),
          selectedRelation,
          selectedParameterValues
        });
      }

    }
    if (this.state.openCombinedPreferences) {
      if (
        (this.state.groupIndexToModify && this.state.bidSequenceToModify) &&
        ((nextState.groupIndexToModify !== this.state.groupIndexToModify || nextState.bidSequenceToModify !== this.state.bidSequenceToModify) ||
          (nextState.groupIndexToModify === this.state.groupIndexToModify && nextState.bidSequenceToModify === this.state.bidSequenceToModify))) {
        const bid = this.state.combinedPreferences[this.state.groupIndexToModify]?.preferences.find(preference => preference.bidSequence === this.state.bidSequenceToModify)
        const selectedParameterValues = [];
        bid?.parameterValues?.forEach(parameter => {
          const param = {
            value: parameter.value,
            parameterId: parameter.parameterId
          };
          selectedParameterValues.push(param);
        });
        if (parameterIndexWithRelations >= 0) {
          selectedRelation = bid?.parameterValues[parameterIndexWithRelations]?.parameterRelation;
        }

        // Don't override selectedRelation if we're editing a combined preference and it's already set
        if (this.isEditingCombinedPreference() && this.state.selectedRelation) {
          this.setState({
            selectedParameterValues
          });
        } else {
          this.setState({
            selectedRelation,
            selectedParameterValues
          });
        }
      }
    }
    this.processFirsTimeAccessBidMode();

    return true;
  }

  async componentDidUpdate(prevProps, prevState) {

    // Clear error messages when switching between different bid types
    if (prevProps.bidPreferenceClasses?.classOptionAttributes?.preferenceOptionId !==
      this.props.bidPreferenceClasses?.classOptionAttributes?.preferenceOptionId) {
      this.clearAllErrorsFromDOM();
    }

    const bidsLengthChanged = prevProps.bidSession?.bidPreferences?.entries?.length !== this.props.bidSession?.bidPreferences?.entries?.length;
    // Check if otherOptions entries changed (length or any value changed)
    const prevActiveWaivers = prevProps.bidSession?.otherOptions?.entries?.filter(opt => opt.value === true)?.length || 0;
    const currActiveWaivers = this.props.bidSession?.otherOptions?.entries?.filter(opt => opt.value === true)?.length || 0;
    const waiverStateChanged = prevActiveWaivers !== currActiveWaivers;
    const bidModeChanged = prevState.bidMode !== this.state.bidMode;

    if (bidsLengthChanged || waiverStateChanged || bidModeChanged) {
      this.filterPreferences(this.state.optionPropertyId);
      // Always rely on API for hasBidSessionRequests
      if (!this.state.justDeletedAll) {
        this.checkBidSessionRequests();
      }
    }
    if (prevProps.bidSession?.bidPreferences?.entries?.length === this.props.bidSession?.bidPreferences?.entries?.length) {
      for (let i = 0; i < prevProps?.bidSession?.bidPreferences?.entries?.length; i++) {
        if (prevProps.bidSession?.filteredBidPreferences?.entries[i]?.score != this.props.bidSession?.filteredBidPreferences?.entries[i]?.score) {
          this.filterPreferences(this.state.optionPropertyId)
        }
        if (
          prevProps.bidSession?.filteredBidPreferences?.entries[i]?.optionLevel !== 505 &&
          this.props.bidSession?.filteredBidPreferences?.entries[i]?.optionLevel !== 505 &&
          prevProps.bidSession?.filteredBidPreferences?.entries[i]?.optionLevel != this.props.bidSession?.filteredBidPreferences?.entries[i]?.optionLevel) {
          this.filterPreferences(this.state.optionPropertyId)
        }
      }
    }
    if (this.state.open) {
      if (
        this.state.editPreference &&
        Object.keys(this.state.editPreference).length !== 0 &&
        prevState.editPreference !== this.state.editPreference &&
        Number.isInteger(this.state.editPreference.optionLevel) &&
        this.state.editPreference.optionLevel !== RESERVE_DOWN_TO.levelNonReserveDownTo
      ) {
        this.setState({
          toggleReserved: true,
          optionLevel: this.state.editPreference.optionLevel
        });
      }
    }
    if (prevProps.bidSession.bidPreferences.totalEntries !== this.props.bidSession.bidPreferences.totalEntries) {
      this.props.updateBidSession(this.props.bidSession)
    }
    if (this.state.openCombinedPreferences) {
      const shouldBeTrue =
        this.state.combinedPreferencesName.length > 85 ||
        this.state.combinedPreferencesName.length === 0 ||
        this.state.combinedPreferences[0].preferences.length === 0 ||
        Object.keys(this.state.copyOfEditCombinedPreferences).length > 0
      if (this.state.combinedDialogNextState !== shouldBeTrue) {
        this.setState({ combinedDialogNextState: shouldBeTrue });
      }
    }
  }

  processFirsTimeAccessBidMode() {
    if (this.state.bidModeSwitched) {
      return;
    }
    this.computeAndSaveBidMode();
    this.setState({ bidModeSwitched: true });
  }

  setDialogButtonLabel = modalScene => {
    const { labels } = this.context || {};
    const BID_TABLE_PROPS = this.props.labels?.BID_TABLE || labels?.BID_TABLE;
    return BID_TABLE_PROPS?.DIALOG?.ACTIONS?.[modalScene];
  };
  setDialogButtonMethod = modalScene => {
    const { labels } = this.context || {};
    const commonLabels_PROPS = this.props.labels?.commonLabels || labels?.commonLabels;
    function isClose() {
      return this.handleRequestClose;
    }
    function isBack() {
      return this.handleBack;
    }
    function isAdd() {
      const admin = sessionStorage.getItem('admin');
      if (admin === commonLabels_PROPS?.ADMIN) {
        return this.handlecommentopen;
      }
      if (this.state.openCombinedPreferences) {
        return this.handleAddCombinedPreferences
      }
      return this.handleAdd;
    }
    const methods = {
      NEXT_STEP1: isAdd.call(this),
      NEXT_STEP2: isAdd.call(this),
      NEXT_STEP3: isAdd.call(this)
    };
    return methods[modalScene];
  };

  handleTouchTap = () => {
    this.setState({
      ...this.state,
      open: true,
      openCombinedPreferences: false,
      statusDisplay: false,
      statusDisplayText: '',
      selectedParameterValues: [],
      dialogNextState: true,
      pairingvalue: ''
    });
  };

  handleCombinedPrefTouchTap = () => {
    this.setState({
      ...this.state,
      open: false,
      openCombinedPreferences: true,
      statusDisplay: false,
      statusDisplayText: '',
      selectedParameterValues: [],
      dialogNextState: true,
      pairingvalue: ''
    });
  };

  handleRequestClose = () => {
    const ADDING_BID = this.props.labels?.ADDING_BID || {};
    const defaultState = this.buildDefaultState();
    this.setState({
      ...defaultState,
      statusDisplay: true,
      statusDisplayText: ADDING_BID.CANCEL_MESSAGE,
      toggleReserved: false,
      optionLevel: null
    }, () => {
      // Re-check if Delete All should be enabled after closing/cancelling
      this.checkBidSessionRequests();
    });
    this.durationHours = [];
    this.durationMinutes = [];
    this.durationFlag = false;
  };

  handleNext = ({ ...args }) => {
    this.hiddenParameters = [];
    const editPreference = !args.openCombinedPreferences ? { ...args.editPreference } : [...args.editPreference];
    const isEditPreference = Object.keys(editPreference).length > 0;
    const { fetchClassOptionAttributes, bidSession } = this.props;


    const optionClassId = isEditPreference && !args.openCombinedPreferences
      ? editPreference.preferenceOptionId
      : this.state.classOption;
    const bidSessionId =
      bidSession.currentBid.bidSessionId || args.bidSessionId;
    const modalScene =
      args.modalScene > 0 && args.modalScene !== '' ? args.modalScene : 1;
    const wish = isEditPreference && !args.openCombinedPreferences ? editPreference.wish : true;
    const maxnn = isEditPreference && !args.openCombinedPreferences ? editPreference.maxnn : null;

    isEditPreference && this.setState({ preferenceOptionIdToDisableAddButton: editPreference.preferenceOptionId })
    this.setState({
      open: (this.state.openCombinedPreferences || args.openCombinedPreferences) ? false : true,
      openCombinedPreferences: this.state.openCombinedPreferences || args.openCombinedPreferences,
      modalScene: !args.openCombinedPreferences ? modalScene + 1 : 2,
      dialogNextState: false,
      wish: Number(wish),
      pairingvalue: '',
      maxnn,
    });
    if (isEditPreference) {
      !args.openCombinedPreferences && this.setState({
        editPreference,
        pairingvalue: '',
        weight: parseInt(editPreference.score, 10)
      });
      args.openCombinedPreferences && this.setState({
        editPreference,
        pairingvalue: '',
        combinedPreferencesName: editPreference[0].preferences[0].groupName,
        combinedPreferences: editPreference,
        editCombinedPreferencesScore: editPreference[0]?.preferences[0]?.score,
      });
    }
    if (!args.openCombinedPreferences) fetchClassOptionAttributes(optionClassId, bidSessionId, this.state.openCombinedPreferences);
    else if (args.openCombinedPreferences && this.state.editPrefFromCombinedPreferenceOptionId) fetchClassOptionAttributes(optionClassId, bidSessionId, this.state.openCombinedPreferences)
  };

  handleBack = () => {
    this.setState({
      modalScene: 1,
      kindofBid: '',
      secondDate: '',
      secondDateUpdated: '',
      betweenDuration: true,
      betweenFirstTime: true,
      dialogNextState: true,
      classOption: null,
      date: false,
      groupIndexToModify: null,
      bidSequenceToModify: null,
      editPrefFromCombinedPreferenceClassId: null,
      editPrefFromCombinedPreferenceOptionId: null,
      selectedParameterValues: [],
      isAddButtonDisabled: false,
      copyOfEditCombinedPreferences: {},
    }, () => {
      // Re-check if Delete All should be enabled after closing/cancelling
      this.checkBidSessionRequests();
    });
  };

  handlePreferenceOptionIdToCheck = (optionId) =>
    this.setState({
      preferenceOptionIdToDisableAddButton: optionId,
      toggleReserved: false,
      optionLevel: null,
    });

  // Date validation handlers
  handleDateError = (parameterSequence, hasError, errorMessage = '') => {

    this.setState(prevState => ({
      dateErrors: {
        ...prevState.dateErrors,
        [parameterSequence]: hasError
      },
      dateErrorMessages: {
        ...prevState.dateErrorMessages,
        [parameterSequence]: errorMessage
      }
    }));
  };

  updateAllDateValues = (parameterSequence, value) => {

    this.setState(prevState => {
      const newAllDateValues = {
        ...prevState.allDateValues,
        [parameterSequence]: value
      };

      return {
        allDateValues: newAllDateValues
      };
    });
  };

  // Clear all error messages from DOM
  clearAllErrorsFromDOM = () => {

    // Reset state
    this.setState({
      dateErrors: {},
      dateErrorMessages: {},
      allDateValues: {}
    });

  };

  handleComponent = (type, parameter) => {
    const DURATION = this.props.labels?.DURATION || {};
    const isEditCombined = (this.state.openCombinedPreferences && this.state.groupIndexToModify !== null && this.state.bidSequenceToModify !== null) ? true : false;
    const combinedBidToEdit = isEditCombined ? this.state.combinedPreferences[this.state.groupIndexToModify]?.preferences.find(preference => preference.bidSequence === this.state.bidSequenceToModify) : {}

    function buildSelectField() {
      if (isEditCombined && parameter.sequence !== 9) parameter.value = combinedBidToEdit?.parameterValues?.find(p => p.parameterId === parameter.parameterId)?.value
      return (
        <DOW
          parameter={parameter}
          handleFormChange={this.handleFormChange}
          handleTargetparameter={this.handleTargetparameter}
          handledateselect={this.handledateselect}
          key={`dow-${parameter.sequence}`}
          isPreferenceParameter
          setSelectedParameterValues={this.setSelectedParameterValues}
          preferenceOptionId={
            this.props.bidPreferenceClasses.classOptionAttributes
              .preferenceOptionId
          }
          toggleReserved={this.state.toggleReserved}
        />
      );
    }

    function buildTextField() {
      return (
        <FLYTEXTFIELD
          parameter={parameter}
          key={`dow-${parameter.sequence}`}
          handleFormChange={this.handleFormChange}
          handleTargetparameter={this.handleTargetparameter}
        />
      );
    }

    function buildMultiSelectField() {
      return (
        <MULTISELECT
          parameter={parameter}
          handleFormChange={this.handleFormChange}
          handleTargetparameter={this.handleTargetparameter}
          key={`multiSelect-${parameter.sequence}`}
          setSelectedParameterValues={this.setSelectedParameterValues}
        />
      );
    }

    function buildListableDate() {
      if (Object.keys(this.state.editPreference).length === 0 && (this.props.bidPreferenceClasses.classOptionAttributes.preferenceOptionId === KINDOFBID.PAIRING_START_ON_DATE ||
        this.props.bidPreferenceClasses.classOptionAttributes.preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_ON_DATES ||
        this.props.bidPreferenceClasses.classOptionAttributes.preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_STARTING_ON_DATES)) {
        this.setState({ dialogNextState: true });
      }

      // Debug: Check what allDateValues we're actually passing

      const componentKey = `${parameter.sequence}-${JSON.stringify(this.state.dateErrors)}-${JSON.stringify(this.state.dateErrorMessages)}`;
      const errorMessageForField = this.state.dateErrorMessages[parameter.sequence || parameter.parameterSequence] || '';

      return (
        <LISTABLEDATE
          parameter={parameter}
          handleFormChange={this.handleFormChange}
          handleTargetparameter={this.handleTargetparameter}
          kindOfBid={this.props.bidPreferenceClasses.classOptionAttributes.name}
          preferenceOptionId={
            this.props.bidPreferenceClasses.classOptionAttributes
              .preferenceOptionId
          }
          disabled={this.state.disabledSecondDate}
          minDate={this.state.secondDate}
          secondDate={this.state.secondDateUpdated}
          key={componentKey}
          pairingName={this.state.pairingvalue}
          pairingdate={
            this.state.pairingvalue === '' ? {} : this.props.pairingdate
          }
          disableDialogSaveButton={this.disableDialogSaveButton}
          setSelectedParameterValues={this.setSelectedParameterValues}
          classOptionAttributes={this.props.bidPreferenceClasses.classOptionAttributes}
          allDateValues={this.state.allDateValues || {}}
          onDateError={this.handleDateError}
          updateAllDateValues={this.updateAllDateValues}
          selectedParameterValues={this.state.selectedParameterValues}
          dateErrorMessage={errorMessageForField}
        />
      );
    }

    /**
     * components for bid options
     * [QUAN = SelectField] | @params {props}
     * [LISTABLEDATE = DatePicker] | @params {props}
     * [TIME = TimePicker] | @params {props}
     * [DOW = SelectField] | @params {props}
     * [LAYSTATION = SelectField] | @params {props}
     * @type {Object}
     */
    const components = {
      QUAN: buildSelectField.call(this),
      STAFFID: buildTextField.call(this),
      LISTABLEDATE: buildListableDate.call(this),
      UNORDEREDDATE: buildListableDate.call(this),
      TIME: (
        <TIME
          parameter={parameter}
          handleFormChange={this.handleFormChange}
          handleTargetparameter={this.handleTargetparameter}
          setHiddenParameter={this.setHiddenParameter}
          preferenceOptionId={
            this.props.bidPreferenceClasses.classOptionAttributes
              .preferenceOptionId
          }
          selectedRelation={this.state.selectedRelation}
          toggleReserved={this.state.toggleReserved}
        />
      ),
      TIMEOFDATETIME: (
        <TIME
          parameter={parameter}
          handleFormChange={this.handleFormChange}
          handleTargetparameter={this.handleTargetparameter}
          setHiddenParameter={this.setHiddenParameter}
          preferenceOptionId={
            this.props.bidPreferenceClasses.classOptionAttributes
              .preferenceOptionId
          }
          selectedRelation={this.state.selectedRelation}
          toggleReserved={this.state.toggleReserved}
        />
      ),
      DOW: buildSelectField.call(this),
      RESERVENAMELIST: buildSelectField.call(this),
      RESERVETYPELIST: buildSelectField.call(this),
      LAYSTATION: buildSelectField.call(this),
      ANYSTATION: buildSelectField.call(this),
      TRIP: buildSelectField.call(this),
      REGION: buildSelectField.call(this),
      ANYSTATIONGENERIC: buildSelectField.call(this),
      LOADSCHEDULE: buildSelectField.call(this),
      EQUIP: buildSelectField.call(this),
      LEG: buildSelectField.call(this),
      DURATION: (
        <div
          className='form-item-container'
          key={`duration-${parameter.sequence}`}
        >
          <DurationInterval
            description={DURATION.DESCRIPTION}
            hourName={'dura-hour'}
            hourHintText={''}
            hourStep={1}
            hourClassName={'medium-4 columns credit-wrapper first-hour'}
            minuteName={'dura-minu'}
            minuteHintText={''}
            minuteStep={1}
            minuteClassName={'medium-4 columns credit-wrapper end'}
            parameter={parameter}
            value={!this.state.openCombinedPreferences ? this.state.editPreference : combinedBidToEdit}
            selectedRelation={this.state.selectedRelation}
            preferenceOptionId={
              this.props.bidPreferenceClasses.classOptionAttributes
                .preferenceOptionId
            }
            setHiddenParameter={this.setHiddenParameter}
            removeHiddenParameter={this.removeHiddenParameter}
            setSelectedParameterValues={this.setSelectedParameterValues}
          />
        </div>
      ),
      RESERVEATTRLIST: buildMultiSelectField.call(this),
      PAIRINGATTRLIST: buildMultiSelectField.call(this)
    };
    return components[type];
  };

  handleScene = () => {
    const { bidSession } = this.props;
    const bidmode = bidSession.bidMode;
    const attributes =
      this.props.bidPreferenceClasses?.classOptionAttributes || {};
    const attributeComponents = [];
    let validRelations = [];

    // Extract labels from props with fallback to context labels
    const { labels } = this.context || {};
    const commonLabels_PROPS = this.props.labels?.commonLabels || labels?.commonLabels;
    const BID_TABLE_PROPS = this.props.labels?.BID_TABLE || labels?.BID_TABLE;
    const CLASSES_PROPS = this.props.labels?.CLASSES || labels?.CLASSES;
    const MAXNN_PROPS = this.props.labels?.MAXNN || labels?.MAXNN;
    const RELATIONS_PROPS = this.props.labels?.RELATIONS || labels?.RELATIONS;
    const RESERVE_DOWN_PROPS = this.props.labels?.RESERVE_DOWN || labels?.RESERVE_DOWN;

    function getParameterAttribute(parameter) {
      let editParameter = {};

      // Handle single bid editing
      if (Object.keys(this.state.editPreference).length > 0 && !Array.isArray(this.state.editPreference)) {
        editParameter = this.state.editPreference.parameterValues.filter(
          param => param.parameterId === parameter.parameterId
        )[0];
        return Object.assign({}, parameter, editParameter);
      }

      // Handle combined preference editing - use selectedParameterValues which is already populated correctly
      if (this.state.openCombinedPreferences && this.state.selectedParameterValues.length > 0) {
        const selectedParam = this.state.selectedParameterValues.find(
          param => param && param.parameterId === parameter.parameterId
        );
        if (selectedParam) {
          return Object.assign({}, parameter, { value: selectedParam.value });
        }
      }

      return parameter;
    }
    const preferenceOptionId =
      this.props.bidPreferenceClasses?.classOptionAttributes?.preferenceOptionId;
    if (attributes.parameters) {
      if (
        bidmode !== undefined &&
        bidmode !== commonLabels_PROPS.NONE &&
        !KINDOFBID.NO_WEIGHT_DISPLAY_BIDS.includes(attributes.preferenceOptionId)
      ) {
        const bidMode = getBidMode();

        if (!this.state.toggleReserved) {
          if (bidMode === commonLabels_PROPS.AUTOMATIC && !this.state.openCombinedPreferences) {
            attributeComponents.push(
              <WEIGHTMODE
                value={this.state.weight}
                weight={this.state.weight}
                handleBidMode={this.handleBidMode}
                handleTargetparameter={this.handleTargetparameter}
                key={`attributeComponents_${attributeComponents.length}`}
              />
            );
          } else if (bidMode === commonLabels_PROPS.LADDER && !this.state.openCombinedPreferences) {
            attributeComponents.push(
              <LADDERMODE
                value={this.state.weight}
                bidSession={bidSession}
                handleBidMode={this.handleBidMode}
                handleGetLevels={this.handleGetLevels}
                handleTargetparameter={this.handleTargetparameter}
                key={`attributeComponents_${attributeComponents.length}`}
              />
            );
          } else if (bidMode === commonLabels_PROPS.MANUAL && !this.state.openCombinedPreferences) {
            attributeComponents.push(
              <WEIGHT
                value={this.state.weight}
                handleWeightChange={this.handleWeightChange}
                handleTargetparameter={this.handleTargetparameter}
                key={`attributeComponents_${attributeComponents.length}`}
              />
            );
          }
        } else if (!this.state.openCombinedPreferences) {
          attributeComponents.push(
            <RESERVEDOWNTO
              value={this.state.optionLevel}
              handleChange={this.handleReserved}
              description={BID_TABLE_PROPS.SLOT}
            />
          );
        }
      }
      if (!attributes.desireFixed) {
        const isEditCombined = (this.state.openCombinedPreferences && this.state.groupIndexToModify !== null && this.state.bidSequenceToModify !== null) ? true : false;
        const combinedBidToEdit = isEditCombined ? this.state.combinedPreferences[this.state.groupIndexToModify]?.preferences.find(preference => preference.bidSequence === this.state.bidSequenceToModify) : {}

        const parameter = {
          allowedValues: {
            0: CLASSES_PROPS.AVOID,
            1: CLASSES_PROPS.DESIRE
          },
          description: CLASSES_PROPS.DESCRIPTION,
          defaultValue: this.state.wish,
          sequence: COMPONENTS.WISH_SEQUENCE,
          type: 'drop',
          value: this.state.wish
        };
        attributeComponents.push(
          <DOW
            parameter={parameter}
            handleFormChange={this.handleFormChange}
            handleTargetparameter={this.handleTargetparameter}
            key={Math.random()}
            toggleReserved={this.state.toggleReserved}
          />
        );
      }
      if (attributes.properties) {
        // eslint-disable-next-line array-callback-return,consistent-return
        const maxnnValue = attributes.properties.filter(Mnn => {
          if (Mnn.name === 'MaxNN') {
            return Mnn;
          }
        });
        // eslint-disable-next-line eqeqeq
        if (maxnnValue.length !== 0) {
          const parameter1 = {
            allowedValues: {
              1: MAXNN_PROPS.ONE,
              2: MAXNN_PROPS.TWO,
              3: MAXNN_PROPS.THREE
            },
            description: MAXNN_PROPS.MAX_DESCRIPTION,
            defaultValue: this.state.maxnn,
            sequence: COMPONENTS.MAXNN_SEQUENCE,
            type: 'drop'
          };
          attributeComponents.push(
            <DOW
              parameter={parameter1}
              handleFormChange={this.handleFormChange}
              handleTargetparameter={this.handleTargetparameter}
              key={12}
              toggleReserved={this.state.toggleReserved}
            />
          );
        }
      }
      attributes.parameters.forEach(parameter => {
        if (parameter.validRelations.length > 1) {
          validRelations = parameter.validRelations;
          // Use selectedRelation from state - it's set correctly in editPrefFromCombined
          const relationValue = this.state.selectedRelation || parameter.validRelations[0];

          const parameterValidRelations = {
            allowedValues: {},
            description: '',
            defaultValue: relationValue,
            sequence: COMPONENTS.RELATION_SEQUENCE,
            type: 'drop',
            value: relationValue
          };
          for (let i = 0; i < validRelations.length; i += 1) {
            const codeRelation = RELATIONS_PROPS[validRelations[i]];
            parameterValidRelations.allowedValues[validRelations[i]] =
              codeRelation;
            if (i === 0) {
              parameterValidRelations.description =
                RELATIONS_PROPS.DESCRIPTION[validRelations[i]];
            }
          }
          attributeComponents.push(
            <DOW
              parameter={parameterValidRelations}
              handleFormChange={this.handleFormChange}
              handleTargetparameter={this.handleTargetparameter}
              kindOfOption={'validRelations'}
              key={Math.random()}
              toggleReserved={this.state.toggleReserved}
            />
          );
        }
        const COMPONENT = parameter.attribute.name
          .replace(/[_-\s]+/g, '')
          .toUpperCase();

        attributeComponents.push(
          this.handleComponent(
            COMPONENT,
            getParameterAttribute.call(this, parameter)
          )
        );
      });
    }

    let editRequestSubtitle;

    if (
      attributes.properties &&
      attributes.properties.find(proprety => proprety.propertyId === 11)
    ) {
      editRequestSubtitle = (
        <span>
          {attributes.description}
          {((bidSession?.displayScope || this.props.isCrewGroupDefault) && this.state.optionPropertyId !== 15) && <FormControlLabel
            control={
              <DefaultCheckbox
                checked={this.state.toggleReserved}
                onChange={() => this.handleCheckboxChange()}
              />
            }
            label={RESERVE_DOWN_PROPS.RESERVE_DOWN_TO_LABEL}
          />
          }
        </span>
      );
    } else editRequestSubtitle = attributes.description;
    return this.state.modalScene < 3 ? (
      <div>
        <div
          className={`${preferenceOptionId ===
            KINDOFBID.STATION_LAYOVER_ON_DATES_PREFERENCE_ID
            ? 'Add-Bid-Item-WrapperDate'
            : 'Add-Bid-Item-Wrapper'
            }`}
        >
          <div className='row flex-component'>
            {attributeComponents}
          </div>
        </div>
      </div>
    ) : (
      <div>
        <CardHead
          title={Object.keys(attributes).length > 0 ? attributes.name : ''}
          subtitle={
            Object.keys(attributes).length > 0 ? editRequestSubtitle : ''
          }
          hasMenu={false}
          headClassName='Add-Bid-Item-Head'
        />
        <div
          className={`${preferenceOptionId ===
              KINDOFBID.STATION_LAYOVER_ON_DATES_PREFERENCE_ID
              ? 'Add-Bid-Item-WrapperDate'
              : 'Add-Bid-Item-Wrapper'
            }`}
        >
          <div className='row flex-component'>
            {attributeComponents}
          </div>
        </div>
      </div>
    );
  };

  handlecommentopen = () => { this.setState({ open: false, commentopen: true, deleteConfirmation: false }) };

  handleChange = event => {
    if (event.target.value.length < 500) {
      if (/^[a-zA-Z0-9\s]*$/.test(event.target.value) === true) {
        this.setState({
          comment: event.target.value,
          adminName: sessionStorage.getItem('admin'),
          commentok: false
        });
      }
    }
  };

  handleCommentOk = () => {
    const ADDING_BID = this.props.labels?.ADDING_BID || {};
    if (this.state.requestType === 'delete') {
      this.setState({
        deleteConfirmation: false,
        requestType: 'delete',
        commentopen: false
      });
      const { deletePreference, handleActionPreference, deleteCombinedPreference } = this.props;
      if (this.state.deleteCombinedPreferenceName) {
        deleteCombinedPreference(
          this.state.delEmployeeBidId,
          this.state.deleteCombinedPreferenceName,
          this.state.comment,
          this.state.adminName
        ).then(response => {
          this.setState({
            statusDisplay: true,
            statusDisplayText: getActionBidMessage(this.state.requestType, ADDING_BID),
            requestType: null,
            commentopen: false
          });
          handleActionPreference(response);
          this.setState({
            comment: '',
            adminName: '',
            commentok: true,
            deleteCombinedPreferenceName: ''
          });
        });
      } else {
        deletePreference(
          this.state.delBidId,
          this.state.delEmployeeBidId,
          this.state.comment,
          this.state.adminName
        ).then(response => {
          this.setState({
            statusDisplay: true,
            statusDisplayText: getActionBidMessage(this.state.requestType, ADDING_BID),
            requestType: null,
            commentopen: false
          });
          handleActionPreference(response);
          this.setState({
            comment: '',
            adminName: '',
            commentok: true
          });
        });
      }
    }
    else if (this.state.openCombinedPreferences) {
      return this.handleAddCombinedPreferences();
    }
    else {
      return this.handleAdd();
    }
  };

  handleSaveError = errorMessage => {
    this.setState({
      ...this.state,
      statusDisplayText: errorMessage
    });
  };

  handleAdd = () => {
    const bidSession = this.props.bidSession ? this.props.bidSession : {};
    const attributes =
      this.props.bidPreferenceClasses.classOptionAttributes || {};
    const optionPropertyId = this.props.optionPropertyId;
    // Set scoreApplicable to true if the bid option supports scoring, otherwise false
    const scoreApplicable = attributes.properties.some(
      prop => prop.propertyId === PROPERTIES.SCORE_PROPERTY_ID
    );
    let parameterValues = [];
    const updateNextAvailableLevel = () => {
      if (getBidMode() !== BidMode.LADDER.biddingMode) {
        return;
      }
      const nextAvailableLevel =
        bidSessionActions.default.getNextAvailableLevel(
          this.props.bidSession.bidPreferences,
          this.props.bidSession.bidLevels,
          this.props.bidSession.allowDuplicates
        );
      this.props.bidSession.nextAvailableLevel = nextAvailableLevel;
    };
    parameterValues = attributes.parameters.filter(parameter => parameter.attribute.attributeId !== UNKNOWN_ATTRIBUTE_ID)
      .map((parameter, index) => ({
        parameterRelation: getParameterRelation(
          this.state.selectedRelation,
          parameter.validRelations
        ),
        parameterId: parameter.parameterId,
        value: getParameterValue(
          this.state.selectedParameterValues,
          attributes.parameters,
          parameter.parameterId,
          this.hiddenParameters.includes(parameter.parameterId)
        ),
        parameterSequence: parameter.sequence
      }));
    // Setting Defaults for undefined Values and for hidden parameters.
    parameterValues.forEach((item, index) => {
      if (
        parameterValues[index].value === undefined ||
        this.hiddenParameters.includes(item.parameterId)
      ) {
        parameterValues[index].value =
          attributes.parameters[index].defaultValue;
      }
    });

    const { savePreference, handleActionPreference, showNotification } = this.props;
    let editPreference;
    if (Object.keys(this.state.editPreference).length > 0) {
      editPreference = this.state.editPreference;
      editPreference.score = parseInt(this.state.weight, 10);
      if (this.state.optionLevel) editPreference.optionLevel = this.state.optionLevel;
    }
    this.setState({
      ...this.state,
      open: false,
      openCombinedPreferences: false,
      commentopen: false,
      modalScene: 1,
      editPreference,
      requestType:
        Object.keys(this.state.editPreference).length > 0 ? 'edit' : 'save'
    });

    let attributeId = attributes?.parameters[0]?.attribute?.attributeId;

    const ADDING_BID = this.props.labels?.ADDING_BID || {};
    // LINE CREDIT, check if editPreference, block if befor & after have the same value
    if (editPreference && parameterValues && attributeId == 15 &&
      parameterValues[0].parameterRelation === VALID_RELATIONS.BETWEEN &&
      parseInt(parameterValues[0].value) === parseInt(parameterValues[1].value)) {
      showNotification(ADDING_BID.LINE_CREDIT?.SAME_VALUES_ERROR)
      this.setState({
        ...this.state,
        open: false,
        modalScene: 1,
        editPreference: {},
        requestType:
          Object.keys(this.state.editPreference).length > 0 ? 'edit' : 'save',
      });
      return
    }

    // LINE CREDIT, check if editPreference, block if befor is higher than after
    if (editPreference && parameterValues && attributeId == 15 &&
      parameterValues[0].parameterRelation === VALID_RELATIONS.BETWEEN &&
      parseInt(parameterValues[0].value) > parseInt(parameterValues[1].value)) {
      showNotification(ADDING_BID.LINE_CREDIT?.BEFORE_AFTER_ERROR)
      this.setState({
        ...this.state,
        open: false,
        modalScene: 1,
        editPreference: {},
        requestType:
          Object.keys(this.state.editPreference).length > 0 ? 'edit' : 'save',
      });
      return
    }

    // LINE CREDIT, block if befor & after have the same value
    if (this.state.classOption === LINE_CREDITS_ID && parameterValues && attributeId == 15 &&
      parameterValues[0].parameterRelation === VALID_RELATIONS.BETWEEN &&
      parameterValues[0].value === parameterValues[1].value) {
      showNotification(ADDING_BID.LINE_CREDIT.SAME_VALUES_ERROR)
      this.setState({
        ...this.state,
        open: false,
        modalScene: 1,
        editPreference: {},
        requestType:
          Object.keys(this.state.editPreference).length > 0 ? 'edit' : 'save',
      });
      return
    }

    // LINE CREDIT, block if befor is higher than after
    if (this.state.classOption === LINE_CREDITS_ID && parameterValues && attributeId == 15 &&
      parameterValues[0].parameterRelation === VALID_RELATIONS.BETWEEN &&
      parameterValues[0].value > parameterValues[1].value) {
      showNotification(ADDING_BID.LINE_CREDIT.BEFORE_AFTER_ERROR)
      this.setState({
        ...this.state,
        open: false,
        modalScene: 1,
        editPreference: {},
        requestType:
          Object.keys(this.state.editPreference).length > 0 ? 'edit' : 'save'
      });
      return
    }
    savePreference(
      bidSession,
      this.state.classOption,
      parameterValues,
      this.state.editPreference,
      !!this.state.wish,
      this.state.maxnn,
      this.state.optionPropertyId,
      this.state.comment,
      this.state.adminName,
      this.state.weight,
      bidSession.bidMode,
      this.state.optionLevel,
      scoreApplicable
    )
      .then(response => {
        if (response.data.errorMessages && response.status !== httpStatus.OK) {
          const newArr = Object.values(response.data.errorMessages);
          const mappedArr = newArr.map(i => i);
          this.handleSaveError(mappedArr.join(', '));
        } else {
          this.setState({
            ...this.state,
            statusDisplayText: getActionBidMessage(this.state.requestType, ADDING_BID),
            toggleReserved: false
          });
          this.durationHours = [];
          this.durationMinutes = [];
          this.durationFlag = false;
          handleActionPreference(response, this.state.requestType === 'save');
          updateNextAvailableLevel();
          this.checkBidSessionRequests(); // Check if button should be enabled after adding
        }
      })
      .catch(error => {
        if (error.response && error.response.data && error.response.data.errorMessages) {
          const newArr = Object.values(error.response.data.errorMessages);
          const mappedArr = newArr.map(i => i);
          this.handleSaveError(mappedArr.join(', '));
        } else {
          this.handleSaveError('Could not save bid.  Please contact Support');
        }
      })
      .finally(() => {
        this.setState({
          ...this.state,
          statusDisplay: true,
          slideIndex: 0,
          secondDateUpdated: '',
          dialogNextState: true,
          classOption: null,
          editPreference: {},
          selectedParameterValues: [],
          kindofBid: '',
          secondDate: '',
          scrollTop: 0,
          betweenDuration: true,
          betweenFirstTime: true,
          commentopen: false,
          comment: '',
          adminName: '',
          commentok: true,
          optionLevel: null,
          toggleReserved: false,
          combinedPreferences: [],
          groupIndex: 0,
          bidSequence: 0,
          combinedPreferencesName: ''
        });

        this.filterPreferences(this.state.optionPropertyId);
        this.checkBidSessionRequests(); // Always re-check after add
      });
  };
  onClearFilter = () => {
    const bidSession = this.props.bidSession ? this.props.bidSession : {};
    const bidSessionId = bidSession.currentBid.bidSessionId;
    const currentCategory = bidSession.user.currentCategory || {};
    const categoryId = currentCategory.categoryId;
    // eslint-disable-next-line no-unused-vars
    const startDayOffset = currentCategory.startDayOffset;
    const staffId = bidSession.user.staffId;
    const currentBid = bidSession.currentBid ? bidSession.currentBid : {};
    let bidStart = currentBid.startDate ? currentBid.startDate : [1969, 12, 31];
    let bidEnd = currentBid.endDate ? currentBid.endDate : [1969, 12, 31];
    // Use Date.UTC to ensure consistent timestamps across all timezones
    bidStart = Date.UTC(bidStart[0], bidStart[1] - 1, bidStart[2]);
    bidEnd = new Date(Date.UTC(bidEnd[0], bidEnd[1] - 1, bidEnd[2]));
    bidEnd = utils.removeDays(bidEnd, 1).getTime();
    const sessionData = {
      categoryId,
      bidSessionId,
      staffId,
      bidSessionDateRange: { startInclusive: bidStart, endInclusive: bidEnd },
      includeBidAnalysis: false
    };
    this.props.resetFilter(sessionData);
  };

  handleWeightChange = weights => {
    if (weights !== '') {
      this.setState({ weight: weights, dialogNextState: false });
    } else if (weights === 0) {
      this.setState({
        weight: BidMode.MANUAL.changedWeight,
        dialogNextState: false
      });
    } else {
      this.setState({
        weight: BidMode.MANUAL.changedWeight,
        dialogNextState: false
      });
    }

    if ((KINDOFBID.PAIRING_ATTR_LIST.includes(this.state.classOption) || KINDOFBID.PAIRING_ATTR_LIST.includes(this.props.bidPreferenceClasses.classOptionAttributes.preferenceOptionId)) &&
      (this.state.selectedParameterValues === undefined || this.state.selectedParameterValues.includes(null)) || this.checkSelectedParameterValuesContainNull(this.state.selectedParameterValues)) {
      this.setState({
        dialogNextState: true
      });
    }
  };

  handleBidMode = weights => { this.setState({ weight: weights }) };

  handleGetLevels = preference => {
    const { bidSessionId } = preference.bidSession.currentBid;
    const { staffId } = preference.bidSession.user;
    const url = `preferences/bids/ladder/levels?bidsession_id=${bidSessionId}&staff_id=${staffId}`;
    return apiCall(url, 'get').then(response => response.data.entries);
  };

  handleFormChange = (...args) => {
    let sequenceIndex = args[3] ? args[3] : '';
    let typeOfInput = args[4] ? args[4] : '';
    const parameterId = args[5] ? args[5] : '';

    const selectedParameterValues = this.state.selectedParameterValues;
    if (args[0] == null) {
      typeOfInput = this.state.targetParameter.slice(0, 4);
      if (!this.props.bidPreferenceClasses.classOptionAttributes.preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_ON_DATES &&
        !this.props.bidPreferenceClasses.classOptionAttributes.preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_STARTING_ON_DATES) {
        sequenceIndex = this.state.targetParameter.slice(-1);
      }

      switch (typeOfInput) {
        case 'date': {
          const formDate = createDateFromDateString(args[1]);
          const dateDay =
            formDate.getDate() < 10
              ? `0${formDate.getDate()}`
              : formDate.getDate();
          const dateMonth =
            formDate.getMonth() + 1 < 10
              ? `0${formDate.getMonth() + 1}`
              : formDate.getMonth() + 1;
          const dateYear = formDate.getFullYear();

          // eslint-disable-next-line no-unused-vars
          const kindOfBid =
            this.props.bidPreferenceClasses.classOptionAttributes.name;
          const preferenceOptionId =
            this.props.bidPreferenceClasses.classOptionAttributes
              .preferenceOptionId;
          selectedParameterValues[sequenceIndex - 1] = {
            value: `${dateYear}-${dateMonth}-${dateDay}`,
            parameterId,
            sequenceIndex
          };
          if (
            sequenceIndex === '1' ||
            (sequenceIndex === '2' &&
              preferenceOptionId ===
              KINDOFBID.STATION_LAYOVER_ON_DATES_PREFERENCE_ID)
          ) {
            this.setState({
              secondDate: `${dateYear}-${dateMonth}-${dateDay}`
            });

            if (
              preferenceOptionId === KINDOFBID.PERIOD_OF_DATES_OFF_PREFERENCE_ID
            ) {
              selectedParameterValues[sequenceIndex] = {
                value: document.getElementById('date-picker-2').value,
                parameterId
              };
            }
            if (
              preferenceOptionId ===
              KINDOFBID.STATION_LAYOVER_ON_DATES_PREFERENCE_ID
            ) {
              selectedParameterValues[sequenceIndex] = {
                value: document.getElementById('date-picker-3').value,
                parameterId
              };
            }
          }
          if (
            (sequenceIndex === '2' &&
              preferenceOptionId !==
              KINDOFBID.STATION_LAYOVER_ON_DATES_PREFERENCE_ID) ||
            (sequenceIndex === '3' &&
              preferenceOptionId ===
              KINDOFBID.STATION_LAYOVER_ON_DATES_PREFERENCE_ID)
          ) {
            this.setState({
              secondDateUpdated: `${dateYear}-${dateMonth}-${dateDay}`
            });
          }

          // Track date values for validation
          this.updateAllDateValues(sequenceIndex, `${dateYear}-${dateMonth}-${dateDay}`);

          break;
        }
        case 'timeOfDateTime':
        case 'time': {
          const clockTime = new Date(args[0]);
          const hours =
            clockTime.getHours() < 10
              ? `0${clockTime.getHours()}`
              : clockTime.getHours();
          const time = `${hours}:${`0${clockTime.getMinutes()}`.slice(-2)}`;
          selectedParameterValues[sequenceIndex - 1] = {
            value: time,
            parameterId
          };
          break;
        }
        default:
          break;
      }
    } else {
      // If DropDown Validation
      if (typeOfInput === '' && sequenceIndex === '') {
        [typeOfInput, sequenceIndex] = this.extractDataSetInfos(args[0].target);
      }
      switch (typeOfInput) {
        case 'text':
          selectedParameterValues[sequenceIndex - 1] = {
            value: args[2].toString(),
            parameterId
          };
          break;
        case 'drop':
          if (sequenceIndex === COMPONENTS.WISH_SEQUENCE) {
            this.setState({ wish: args[2] });
          }
          if (sequenceIndex === COMPONENTS.MAXNN_SEQUENCE) {
            this.setState({ maxnn: args[2] });
          }
          if (sequenceIndex === COMPONENTS.RELATION_SEQUENCE) {
            const betweenDuration = args[2] === 'BETWEEN_RELATION_CODE';
            this.hiddenParameters = [];
            this.setState({
              betweenDuration,
              selectedRelation: args[2],
              betweenFirstTime: false
            });
          } else {
            const bidArgString = args[2].toString();
            selectedParameterValues[sequenceIndex - 1] = {
              value: bidArgString || null,
              parameterId
            };
          }
          break;
        case 'dura': {
          // Now the state updates of the Duration (NumericRange) component is being
          // managed by the component itself
          break;
        }
        case 'time': {
          selectedParameterValues[sequenceIndex - 1] = {
            value: args[0] || null,
            parameterId
          };
        }
        default:
          break;
      }
    }

    this.setState({
      selectedParameterValues,
      dialogNextState: this.optionOnlyHasUnknown
        ? !this.optionOnlyHasUnknown
        : (selectedParameterValues.includes(null) || this.checkSelectedParameterValuesContainNull(selectedParameterValues))
    });

    if (this.props.bidPreferenceClasses.classOptionAttributes.preferenceOptionId === KINDOFBID.PAIRING_START_ON_DATE ||
      this.props.bidPreferenceClasses.classOptionAttributes.preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_ON_DATES ||
      this.props.bidPreferenceClasses.classOptionAttributes.preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_STARTING_ON_DATES) {
      this.setState({ dialogNextState: this.areSelectedPairingDatesInvalid(this.props.bidPreferenceClasses.classOptionAttributes.preferenceOptionId) });
    }

    if (
      this.state.openCombinedPreferences &&
      Object.keys(this.state.copyOfEditCombinedPreferences).length > 0

    ) {
      let newValues = deepClone(this.state.copyOfEditCombinedPreferences);

      // Get the current wish value - use the updated value if this is a wish change
      const currentWishValue = (sequenceIndex === COMPONENTS.WISH_SEQUENCE && typeOfInput === 'drop')
        ? args[2]
        : this.state.wish;

      if (sequenceIndex === COMPONENTS.RELATION_SEQUENCE && typeOfInput === 'drop') {
        // Find the parameter that has multiple validRelations (the one with the relation dropdown)
        const attributes = this.props.bidPreferenceClasses.classOptionAttributes;
        if (attributes && attributes.parameters) {
          const paramWithRelations = attributes.parameters.find(param => param.validRelations.length > 1);
          if (paramWithRelations) {
            const paramIndex = newValues.parameterValues.findIndex(param => param.parameterId === paramWithRelations.parameterId);
            if (paramIndex >= 0) {
              newValues.parameterValues[paramIndex].parameterRelation = args[2];
            }
          }
        }
        validateDifferentValue(
          this.state.copyOfEditCombinedPreferences,
          { parameterValues: newValues.parameterValues, wish: currentWishValue },
          this.handleisAddButtonDisabled
        )
      } else {
        validateDifferentValue(
          this.state.copyOfEditCombinedPreferences,
          { parameterValues: this.state.selectedParameterValues, wish: currentWishValue },
          this.handleisAddButtonDisabled
        )
      }
    }
  };

  handledateselect = (value, bidOptionId) => {
    const bidSession = this.props.bidSession ? this.props.bidSession : {};
    const currentBid = bidSession.currentBid ? bidSession.currentBid : {};
    const staffId = bidSession.user.staffId;
    let bidStart = bidSession.user.currentCategory.startDayOffset;

    bidStart = bidStart[1];
    const pairingName = value;
    const optionId = bidOptionId || this.props.classOptionAttributes?.preferenceOptionId;

    this.setState({ dialogNextState: false });
    this.props.fetchdate(pairingName, staffId, bidStart, optionId);
  };

  extractDataSetInfos = target => {
    if (target.id !== '') {
      return this.extractTypeOfInputAndSequenceIndex(target);
    }

    const dataSet = this.searchForParentNodeWithDataset(target);
    return this.extractTypeOfInputAndSequenceIndex(dataSet);
  };

  extractTypeOfInputAndSequenceIndex = dataset => {
    const id = dataset.id;
    const typeOfInput = id ? id.slice(0, 4) : '';
    const sequenceIndex = id ? id.slice(-1) : '';
    return [typeOfInput, sequenceIndex];
  };

  searchForParentNodeWithDataset = target => {
    let parentNode = target;
    while (!parentNode.dataset.id) {
      parentNode = parentNode.parentNode;
    }
    return parentNode.dataset;
  };

  setHiddenParameter = parameterId => {
    if (!this.hiddenParameters.includes(parameterId)) {
      this.hiddenParameters.push(parameterId);
    }
  };

  removeHiddenParameter = parameterId => {
    if (this.hiddenParameters.includes(parameterId)) {
      const index = this.hiddenParameters.indexOf(parameterId);
      if (index > -1) {
        this.hiddenParameters.splice(index, 1);
      }
    }
  };

  setSelectedParameterValues = (index, value, parameterId) => {
    const selectedParameterValues = [...this.state.selectedParameterValues];
    const { preferenceOptionId } = this.props.bidPreferenceClasses.classOptionAttributes;

    // Handle pairing changes for specific bid types (132, 234, and 784)
    const isPairingBidWithDates = (preferenceOptionId === KINDOFBID.PAIRING_START_ON_DATE ||
      preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_ON_DATES ||
      preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_STARTING_ON_DATES);

    if (isPairingBidWithDates && index === 0) {
      // Check if the pairing value is actually changing
      const currentPairingValue = this.state.selectedParameterValues[0]?.value;
      const isValueChanged = currentPairingValue !== value;

      if (isValueChanged) {
        // Clear all date parameters when pairing changes (but not DESIRE/AVOID at index 8)
        for (let i = 1; i < selectedParameterValues.length; i++) {
          if (selectedParameterValues[i] && i !== 8) {
            selectedParameterValues[i] = {
              value: "",
              parameterId: selectedParameterValues[i].parameterId
            };
          }
        }
        // Set flag to prevent restoration of old date values
        this.setState({ datesClearedForPairing: true });

        // Clear any existing timeout
        if (this.dateClearTimeout) {
          clearTimeout(this.dateClearTimeout);
        }

        // Reset flag after a longer delay to handle multiple rapid calls
        this.dateClearTimeout = setTimeout(() => {
          this.setState({ datesClearedForPairing: false });
          this.dateClearTimeout = null;
        }, 500);
      }
    } else if (isPairingBidWithDates && index > 0 && index !== 8 && this.state.datesClearedForPairing) {
      // Prevent old date values from being restored if we just cleared them
      // But allow DESIRE/AVOID input (index 8) to be set normally
      if (value !== "" && value !== null && value !== undefined) {
        return; // Don't update with old value
      }
    }

    // Special handling for DESIRE/AVOID input at index 8
    if (index === 8 && parameterId === '') {
      // Ensure array is large enough
      while (selectedParameterValues.length <= 8) {
        selectedParameterValues.push(null);
      }
    }

    selectedParameterValues[index] = { value, parameterId };
    this.setState({
      selectedParameterValues,
      dialogNextState: this.optionOnlyHasUnknown
        ? !this.optionOnlyHasUnknown
        : (selectedParameterValues.includes(null) || this.checkSelectedParameterValuesContainNull(selectedParameterValues))
    });

    if ((preferenceOptionId === KINDOFBID.PAIRING_START_ON_DATE || KINDOFBID.SPECIFIC_PAIRING_ON_DATES) && index === 0) {
      this.setState({
        pairingvalue: value
      });
    }

    if (
      Object.keys(this.state.copyOfEditCombinedPreferences).length > 0
    ) {
      let newValues = deepClone(this.state.copyOfEditCombinedPreferences);

      // Handle DESIRE/AVOID input differently
      if (index === 8 && parameterId === '') {
        // For DESIRE/AVOID input, treat as wish value change
        newValues.wish = parseInt(value);
        validateDifferentValue(this.state.copyOfEditCombinedPreferences, newValues, this.handleisAddButtonDisabled);
      } else if (
        !newValues.parameterValues ||
        newValues.parameterValues.length === 0 ||
        newValues.parameterValues[index] === undefined ||
        newValues.parameterValues[index] === null ||
        newValues.parameterValues[index].parameterId !== parameterId
      ) {
        return;
      } else {
        newValues.parameterValues[index].value = value;
        validateDifferentValue(this.state.copyOfEditCombinedPreferences, newValues, this.handleisAddButtonDisabled);
      }
    }
  };

  disableDialogSaveButton = () => {
    this.setState({
      dialogNextState: true
    });
  }

  checkSelectedParameterValuesContainNull(selectedParameterValues) {
    if (KINDOFBID.PAIRING_ATTR_LIST.includes(this.state.classOption) || KINDOFBID.PAIRING_ATTR_LIST.includes(this.props.bidPreferenceClasses.classOptionAttributes.preferenceOptionId)) {
      if (selectedParameterValues.length === 0 || selectedParameterValues[0].value === undefined) {
        return true;
      }
    }
    return false;
  }

  handleTargetparameter = e => {
    if (this.props.bidPreferenceClasses.classOptionAttributes.preferenceOptionId === KINDOFBID.PAIRING_START_ON_DATE ||
      this.props.bidPreferenceClasses.classOptionAttributes.preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_ON_DATES ||
      this.props.bidPreferenceClasses.classOptionAttributes.preferenceOptionId === KINDOFBID.SPECIFIC_PAIRING_STARTING_ON_DATES) {
      this.setState({ targetParameter: 'date-picker-2' });
    } else {
      this.setState({ targetParameter: e.target.id });
    }
  }

  closeStatusDisplay = () => {
    this.setState({
      statusDisplay: false,
      statusDisplayText: ''
    });
  };

  handleDeleteCombinedPreference = (groupName, employeeBidId) => {
    this.setState({
      deleteConfirmation: true,
      deleteCombinedPreferenceName: groupName,
      delEmployeeBidId: employeeBidId
    });
  };

  handleDeletePreference = (bidId, employeeBidId) => {
    this.setState({
      deleteConfirmation: true,
      delBidId: bidId,
      delEmployeeBidId: employeeBidId
    });
  }

  handleDeleteAllPreference = () => {
    this.setState({
      deleteAllConfirmation: true
    });
  };

  handleCloseDeletePreference = () => {
    this.setState({ deleteConfirmation: false });
  };

  handleCloseDeleteAllPreference = () => {
    this.setState({ deleteAllConfirmation: false });
  };

  /**
   * Deletes a bid preference.
   */
  deletePreferenceAction = () => {
    const commonLabels = this.props.labels?.commonLabels || {};
    const ADDING_BID = this.props.labels?.ADDING_BID || {};
    const admin = sessionStorage.getItem('admin');
    const updateNextAvailableLevel = () => {
      if (getBidMode() !== BidMode.LADDER.biddingMode) {
        return;
      }
      const nextAvailableLevel =
        bidSessionActions.default.getNextAvailableLevel(
          this.props.bidSession.bidPreferences,
          this.props.bidSession.bidLevels,
          this.props.bidSession.allowDuplicates
        );
      this.props.bidSession.nextAvailableLevel = nextAvailableLevel;
    };
    if (admin === commonLabels?.ADMIN) {
      this.setState({ requestType: 'delete' });
      this.handlecommentopen();
    } else {
      this.setState({ deleteConfirmation: false, requestType: 'delete' });
      const { deletePreference, handleActionPreference, deleteCombinedPreference } = this.props;
      if (this.state.deleteCombinedPreferenceName) {
        deleteCombinedPreference(
          this.state.delEmployeeBidId,
          this.state.deleteCombinedPreferenceName
        ).then(response => {
          this.setState({
            statusDisplay: true,
            statusDisplayText: getActionBidMessage(this.state.requestType, ADDING_BID),
            deleteCombinedPreferenceName: ''
          });
          handleActionPreference(response);
          updateNextAvailableLevel();
          this.filterPreferences(this.state.optionPropertyId);
          this.checkBidSessionRequests(); // Check if any requests remain
        }).finally(() => {
          this.checkBidSessionRequests(); // Always re-check after delete
        });
      } else {
        deletePreference(this.state.delBidId, this.state.delEmployeeBidId).then(
          response => {
            this.setState({
              statusDisplay: true,
              statusDisplayText: getActionBidMessage(this.state.requestType, ADDING_BID)
            });
            handleActionPreference(response);
            updateNextAvailableLevel();
            this.filterPreferences(this.state.optionPropertyId);
            this.checkBidSessionRequests(); // Check if any requests remain
          }
        ).finally(() => {
          this.checkBidSessionRequests(); // Always re-check after delete
        });
      }
    }
    updateNextAvailableLevel();
  };


  /**
   * Deletes all bid preferences for the current bid session.
   */
  deleteAllPreferenceAction = async () => {
    const { bidSession, deleteAllPreferences, handleActionPreference, fetchBidSession, onPreferencesCleared } = this.props;
    const ADDING_BID = this.props.labels?.ADDING_BID || {};

    const updateNextAvailableLevel = () => {
      if (getBidMode() !== BidMode.LADDER.biddingMode) return;
      const nextAvailableLevel =
        bidSessionActions.default.getNextAvailableLevel(
          bidSession.bidPreferences,
          bidSession.bidLevels,
          bidSession.allowDuplicates
        );
      bidSession.nextAvailableLevel = nextAvailableLevel;
    };

    try {
      const response = await deleteAllPreferences(
        bidSession.user.staffId,
        bidSession.currentBid.bidSessionId
      );

      // Check if there are error messages in the response
      let statusMessage = getActionBidMessage('delete', ADDING_BID);
      const hasErrors = response?.data?.errorMessages && Object.keys(response.data.errorMessages).length > 0;

      if (hasErrors) {
        // Get the first error message
        const firstErrorKey = Object.keys(response.data.errorMessages)[0];
        statusMessage = response.data.errorMessages[firstErrorKey];
      }

      this.setState({
        deleteAllConfirmation: false,
        requestType: 'delete',
        statusDisplay: true,
        statusDisplayText: statusMessage,
        filteredBidPreferences: { entries: [] }, // Clear filtered preferences immediately
        hasBidSessionRequests: false, // Immediately disable the button after deleting all
        justDeletedAll: true, // Prevent race conditions
      }, () => {
        // Update bidSession props to ensure UI sync with parent
        if (this.props.bidSession) {
          this.props.bidSession.bidPreferences = { ...this.props.bidSession.bidPreferences, entries: [] };
          this.props.bidSession.filteredBidPreferences = { entries: [] };
          // Clear waivers by setting all values to false (maintaining the entries structure)
          if (this.props.bidSession.otherOptions?.entries) {
            this.props.bidSession.otherOptions = {
              ...this.props.bidSession.otherOptions,
              entries: this.props.bidSession.otherOptions.entries.map(opt => ({ ...opt, value: false }))
            };
          }

          // Update parent component's bidSession state
          if (this.props.updateBidSession) {
            this.props.updateBidSession(this.props.bidSession);
          }
        }

        // Reset the justDeletedAll flag after a delay to allow normal behavior again
        setTimeout(() => {
          this.setState({ justDeletedAll: false });
        }, 2000);

        // Always re-check after delete all
        this.checkBidSessionRequests();
      });

      if (response?.data?.revision) {
        handleActionPreference(response);
      }

      updateNextAvailableLevel();

      if (onPreferencesCleared) {
        onPreferencesCleared();
      }

      // Only re-check if there were errors (some requests might not have been deleted)
      if (hasErrors) {
        setTimeout(() => this.checkBidSessionRequests(), 1000);
      }

    } catch (error) {

      this.setState({
        deleteAllConfirmation: false,
        statusDisplay: true,
        statusDisplayText: getActionBidMessage('deleteAllError', ADDING_BID),
      });

      return;
    }
  };


  /**
   * Filters bid preferences based on the selected option property ID.
   * @param {*} optionPropertyId - The option property ID to filter preferences by.
   */
  filterPreferences(optionPropertyId) {
    this.props.bidSession.filteredBidPreferences.entries =
      this.props.bidSession?.bidPreferences?.entries?.filter(preference => preference.preferenceOptionPropertyId === optionPropertyId);
    this.setState({
      filteredBidPreferences: this.props.bidSession.filteredBidPreferences
    })
  }


  handleTabState = (classOption, slideIndex, scrollTop, bidSession) => {
    const { labels } = this.context || {};
    const commonLabels = this.props.labels?.commonLabels || labels?.commonLabels || {};
    let bidLevelDefault;
    const updateNextAvailableLevel = () => {
      if (getBidMode() !== BidMode.LADDER.biddingMode) {
        return;
      }
      const nextAvailableLevel =
        bidSessionActions.default.getNextAvailableLevel(
          this.props.bidSession.bidPreferences,
          this.props.bidSession.bidLevels,
          this.props.bidSession.allowDuplicates
        );
      this.props.bidSession.nextAvailableLevel = nextAvailableLevel;
    };
    if (getBidMode() === BidMode.LADDER.biddingMode) {
      updateNextAvailableLevel();
      if (bidSession && bidSession.nextAvailableLevel !== undefined) {
        bidLevelDefault = bidSession.nextAvailableLevel;
      }
    }
    const weightDefault =
      getBidMode() === BidMode.AUTOMATIC.biddingMode
        ? 2
        : getBidMode() === BidMode.LADDER.biddingMode
          ? bidLevelDefault
          : BidMode.MANUAL.changedWeight;
    // TO FIX
    // // let dialogNextStateValue = this.state.openCombinedPreferences ?
    //   (this.state.combinedPreferences[0].preferences.length !== 0 && this.state.combinedPreferencesName !== '') ? false : true : true;
    this.setState(
      {
        dialogNextState: false,
        classOption,
        slideIndex,
        scrollTop,
        secondDate: '',
        secondDateUpdated: '',
        date: false,
        weight: weightDefault,
        toggleReserved: false
      },
      () => {
        this.handleNext({
          modalScene: this.state.modalScene,
          editPreference: null,
          bidSessionId: bidSession.currentBid.id
        });
      }
    );
  };

  resetRadio = () => {
    this.setState({
      dialogNextState: true,
      classOption: null,
      date: false
    });
  };

  handleToggle = e => {
    e.preventDefault();
    this.handleOpen();
  };

  handleBidScope = e => {
    e.preventDefault();
    if (this.props.readOnly) {
      this.handleOkBidScopeConfirmation();
    } else {
      this.handleOpenBidScopeConfirmation();
    }
  }

  switchWeightBidMode() {
    const { bidSession } = this.props;
    const bidMode = bidSession.bidMode;
    if (!this.isWeightMode(bidMode)) {
      return bidMode;
    }
    let switchedBidMode;
    if (bidMode === BidMode.AUTOMATIC.biddingMode) {
      switchedBidMode = BidMode.MANUAL.biddingMode;
    } else {
      switchedBidMode = BidMode.AUTOMATIC.biddingMode;
    }
    saveBidMode(switchedBidMode);
    return switchedBidMode;
  }

  updateBidMode = (bidMode, defaultvalue) => {
    const { bidSession } = this.props;
    const bidPreference = {
      bidSessionId: bidSession.currentBid.bidSessionId,
      staffId: bidSession.user.staffId,
      employeeBidId: 0,
      bidAggregateId: 0,
      bidSessionSnapshotId: 0,
      preferenceOptionId: 0,
      preferenceOptionPropertyId: 0,
      score: defaultvalue
    };
    saveBidMode(bidMode);
    const newToggled = BidMode.MANUAL.biddingMode === bidMode;
    this.setState({ toggled: newToggled });
    this.setState({ bidMode });
    this.setState({ bidModeSwitched: true });
    const updatedSession = this.buildUpdatedSession(
      bidSession,
      bidMode,
      defaultvalue
    );
    const prefIds = bidSession.bidPreferences.entries.map(preference => preference.bidAggregateId);
    this.props.updateBidSession(updatedSession);
    this.props.updateWeightAll(bidPreference, defaultvalue, bidMode, prefIds);
  };

  handleOk = () => {
    this.setState({ changeWeightConfirmation: false });
    const currentInputCheckedValue = this.state.toggled;
    const newInputCheckedValue = !currentInputCheckedValue;
    this.setState({ toggled: newInputCheckedValue });
    const newBidMode = this.switchWeightBidMode();
    this.updateBidMode(newBidMode, BidMode[newBidMode].changedWeight);
  };

  handleOpen = () => { this.setState({ changeWeightConfirmation: true }) };

  handleClose = () => { this.setState({ changeWeightConfirmation: false }) };

  handleOpenBidScopeConfirmation = () => { this.setState({ changeBidScopeConfirmation: true }) }

  handleCloseBidScopeConfirmation = () => { this.setState({ changeBidScopeConfirmation: false }) }

  handleOkBidScopeConfirmation = () => {
    this.setState({ changeBidScopeConfirmation: false });
    const currentBidScope = this.state.bidScope;
    const newBidScope = currentBidScope === REGULAR_BID_SCOPE ? RESERVE_BID_SCOPE : REGULAR_BID_SCOPE;
    this.setState({ bidScope: newBidScope });
    sessionStorage.setItem(LAST_BID_SCOPE_USE, newBidScope);

    // Dispatch custom event to notify components about the change
    window.dispatchEvent(new CustomEvent('lastBidScopeUsedChanged', {
      detail: { oldValue: currentBidScope, newValue: newBidScope }
    }));

    const bidOptionPropertyValue = this.getBidOptionPropertyValue(newBidScope);
    this.setState({ optionPropertyId: bidOptionPropertyValue })
    this.filterPreferences(bidOptionPropertyValue);
  }

  getBidOptionPropertyValue = bidScope => { return bidScope === REGULAR_BID_SCOPE ? BID_TYPES.REGULAR : BID_TYPES.RESERVE }

  handleToogleReserved = e => {
    e.preventDefault();
    this.setState({ toggleReserved: !this.state.toggleReserved });
  };

  handleReserved = e => {
    e.preventDefault();
    this.setState({ optionLevel: e.target.value });
  };

  handleCheckboxChange = () => {
    this.setState({
      toggleReserved: !this.state.toggleReserved,
      optionLevel: !this.state.toggleReserved ? RESERVE_DOWN_TO.levelAny : null,
      weight: this.props.bidSession.bidMode === BidMode.AUTOMATIC.biddingMode ? (!this.state.toggleReserved ? null : 2) : (!this.state.toggleReserved ? null : 500),
      editPreference: Object.keys(this.state.editPreference || {}).length > 0 ? {
        ...this.state.editPreference,
        optionLevel: (!this.state.toggleReserved ? RESERVE_DOWN_TO.levelAny : null)
      } : this.state.editPreference,
      wish: this.state.toggleReserved
    });
  };

  handleisAddButtonDisabled = (value) => this.setState({ isAddButtonDisabled: value });

  handleAddCombinedPreferences = () => {
    const ADDING_BID = this.props.labels?.ADDING_BID || {};
    const combinedPreferences = this.state.combinedPreferences;
    const employeeBidId = this.state.employeeBidId;
    const updateNextAvailableLevel = () => {
      if (getBidMode() !== BidMode.LADDER.biddingMode) {
        return;
      }
      const nextAvailableLevel =
        bidSessionActions.default.getNextAvailableLevel(
          this.props.bidSession.bidPreferences,
          this.props.bidSession.bidLevels,
          this.props.bidSession.allowDuplicates
        );
      this.props.bidSession.nextAvailableLevel = nextAvailableLevel;
    };
    let payload = { preferences: [] };

    for (let i = 0; i < combinedPreferences.length; i++) {
      for (let j = 0; j < combinedPreferences[i].preferences.length; j++) {
        combinedPreferences[i].preferences[j].groupName = this.state.combinedPreferencesName;
        combinedPreferences[i].preferences[j].employeeBidId = employeeBidId;
        payload.preferences.push(combinedPreferences[i].preferences[j]);
      }
    }

    this.setState({ commentopen: false, loadingBidTable: true });
    this.props.saveCombinedPreference(payload, this.props.bidSession, this.state.editPreference).then(response => {
      if (response.data.errorMessages && response.status !== httpStatus.OK) {
        this.setState({ loadingBidTable: false, errorCombined: true })
        const newArr = Object.values(response.data.errorMessages);
        const mappedArr = newArr.map(i => i);
        this.handleSaveError(mappedArr.join(', '));
        return
      } else {
        this.setState({
          statusDisplayText: getActionBidMessage(Object.keys(this.state.editPreference || {}).length > 0 ? 'edit' : 'save', ADDING_BID),
          toggleReserved: false,
          openCombinedPreferences: false,
          modalScene: 1,
          loadingBidTable: false,
          combinedPreferences: [],
          groupIndex: 0,
          bidSequence: 0,
          combinedPreferencesName: '',
          selectedParameterValues: [],
          classOption: null,
          errorCombined: false,
          dialogNextState: true,
          editPrefFromCombinedPreferenceClassId: null,
          editPrefFromCombinedPreferenceOptionId: null,
          groupIndexToModify: null,
          bidSequenceToModify: null,
          wish: 0,
          disableCancel: true

        });
        this.durationHours = [];
        this.durationMinutes = [];
        this.durationFlag = false;
        this.props.handleActionPreference(response, this.state.requestType === 'save');
        updateNextAvailableLevel();
        this.checkBidSessionRequests(); // Check if button should be enabled after adding
      }
    })
      .catch(error => {
        if (error.errorMessages) {
          this.setState({ loadingBidTable: false, errorCombined: true })
          const newArr = Object.values(error.errorMessages);
          const mappedArr = newArr.map(i => i);
          this.handleSaveError(mappedArr.join(', '));
          return
        } else {
          this.setState({ loadingBidTable: false, errorCombined: true })
          this.handleSaveError('Could not save bid.  Please contact Support');
        }
      }).finally(() => {
        this.setState({
          editPreference: {},
          slideIndex: 0,
          secondDateUpdated: '',
          statusDisplay: true,
          kindofBid: '',
          secondDate: '',
          scrollTop: 0,
          betweenDuration: true,
          betweenFirstTime: true,
          commentopen: false,
          comment: '',
          adminName: '',
          commentok: true,
          optionLevel: null,
          toggleReserved: false,
          loadingBidTable: false,
          classOption: null,
          editPrefFromCombinedPreferenceClassId: null,
          editPrefFromCombinedPreferenceOptionId: null,
          groupIndexToModify: null,
          bidSequenceToModify: null,
          wish: 0,
          disableCancel: true,
          editCombinedPreferencesScore: null
        });
      });
  }

  addBidToGroupeSequence = (bid, groupIndex) => {
    const { labels } = this.context || {};
    const COMBINED_PREFERENCES_PROPS = this.props.labels?.COMBINED_PREFERENCES || labels?.COMBINED_PREFERENCES;
    
    const bidSession = this.props.bidSession ? this.props.bidSession : {};
    let array = [...this.state.combinedPreferences]
    let bidPreference = { ...bid }

    const attributes =
      this.props.bidPreferenceClasses.classOptionAttributes || {};
    let parameterValues = [];

    parameterValues = attributes.parameters.filter(parameter => parameter.attribute.attributeId !== UNKNOWN_ATTRIBUTE_ID)
      .map((parameter, index) => ({
        parameterRelation: getParameterRelation(
          this.state.selectedRelation,
          parameter.validRelations
        ),
        parameterId: parameter.parameterId,
        value: getParameterValue(
          this.state.selectedParameterValues,
          attributes.parameters,
          parameter.parameterId,
          this.hiddenParameters.includes(parameter.parameterId)
        ),
        parameterSequence: parameter.sequence
      }));
    // Setting Defaults for undefined Values and for hidden parameters.
    parameterValues.forEach((item, index) => {
      if (
        parameterValues[index].value === undefined ||
        this.hiddenParameters.includes(item.parameterId)
      ) {
        parameterValues[index].value =
          attributes.parameters[index].defaultValue;
      }
    });
    let validBidToAdd = true
    // to fix the check if you try to add a bid with null values
    // for(let i = 0; i < parameterValues.length; i++) {
    //   if(parameterValues[i].value === null) {
    //     validBidToAdd = false
    //   }
    // }

    if (!validBidToAdd) {
      alert('Please fill all the fields')
    } else if (limitToOneBidPerGroup(array[groupIndex].preferences, bidPreference)) {
      alert(COMBINED_PREFERENCES_PROPS.LIMIT_ONE_BID_PER_GROUP)
      return
    } else {
      const bidData = {
        bidSessionId: bidSession.currentBid.bidSessionId,
        staffId: bidSession.user.staffId,
        preferenceOptionId: bidPreference.preferenceOptionId,
        preferenceOptionPropertyId: this.state.optionPropertyId,
        parameterValues: parameterValues,
        wish: !!this.state.wish,
        maxnn: this.state.maxnn,
        adminComments: this.state.comment,
        adminName: this.state.adminName,
        bidMode: bidSession.bidMode,
        name: bidPreference.name,
        preferenceClassId: bidPreference.preferenceClassId,
        score: this.state.editCombinedPreferencesScore,

        groupSequence: array[groupIndex].groupSequence,
        bidSequence: array[groupIndex].preferences.length + 1,
      }

      this.props.getPreferencesDescription(bidData).then(response => {
        bidData.description = response.data
        array[groupIndex].preferences.push(bidData)
        if (this.state.combinedPreferencesName === '') {
          this.setState({ combinedPreferences: array, dialogNextState: true });
        } else {
          this.setState({ combinedPreferences: array, dialogNextState: false, selectedParameterValues: [] });
        }
      })
    }
  }

  movePreference = (groupSequence, bidSequence, direction) => {
    // Find the target group by groupSequence
    const groupIndex = this.state.combinedPreferences.findIndex(group => group.groupSequence === groupSequence);
    if (groupIndex === -1) {
      console.error("Group not found");
      return;
    }

    const newCombinedPreferences = [...this.state.combinedPreferences];
    const group = newCombinedPreferences[groupIndex];
    const preferences = group.preferences;

    // Find the index of the object to move by bidSequence
    const index = preferences.findIndex(pref => pref.bidSequence === bidSequence);
    if (index === -1) {
      console.error("Preference not found in the group");
      return;
    }

    // Calculate the new index based on the direction
    const newIndex = direction === "up" ? index - 1 : direction === "down" ? index + 1 : index;

    // Ensure the new index is within bounds
    if (newIndex < 0 || newIndex >= preferences.length) {
      console.error("New index is out of bounds");
      return;
    }

    // Swap the object with the one at the new index and switch their bidSequence values
    const temp = preferences[index];
    preferences[index] = preferences[newIndex];
    preferences[newIndex] = temp;

    // Switch their bidSequence values
    const tempBidSequence = preferences[index].bidSequence;
    preferences[index].bidSequence = preferences[newIndex].bidSequence;
    preferences[newIndex].bidSequence = tempBidSequence;

    this.setState({ combinedPreferences: newCombinedPreferences }, () => {
      // Always re-check after reorder
      this.checkBidSessionRequests();
    });
  };

  copyPreference = (employeeBidId, groupName) => { this.props.copyCombinedPreference(employeeBidId, groupName) }

  editPrefFromCombined = (groupIndex, bidSequence, preferenceOptionId) => {
    const bid = this.state.combinedPreferences[groupIndex].preferences.find(preference => preference.bidSequence === bidSequence);

    // Always map parameterValues to { value, parameterId } for selectedParameterValues
    const selectedParameterValues = bid.parameterValues.map(parameter => ({
      value: parameter.value,
      parameterId: parameter.parameterId
    }));

    const copyOfEditCombinedPreferences = {
      parameterValues: bid.parameterValues,
      wish: bid.wish ? 1 : 0
    };
    const preferenceClassId = this.props.bidPreferenceClasses.preferenceOptions.entries.find(preference => preference.preferenceOptionId === bid.preferenceOptionId).preferenceClassId;

    this.setState({
      classOption: bid.preferenceOptionId,
      editPrefFromCombinedPreferenceClassId: preferenceClassId,
      groupIndexToModify: groupIndex,
      bidSequenceToModify: bidSequence,
      wish: bid.wish ? 1 : 0,
      disableCancel: false,
      openCombinedPreferences: true,
      selectedParameterValues: selectedParameterValues, // Use cleaned values for all components
      copyOfEditCombinedPreferences: deepFreeze(deepClone(copyOfEditCombinedPreferences)),
      isAddButtonDisabled: true,
      preferenceOptionIdToDisableAddButton: preferenceOptionId
    }, () => {
      this.props.fetchClassOptionAttributes(bid.preferenceOptionId, bid.bidSessionId, this.state.openCombinedPreferences);
    });
  }

  saveEditPrefFromCombined = () => {
    const bidSession = this.props.bidSession ? this.props.bidSession : {};
    let array = [...this.state.combinedPreferences]
    const bid = this.state.combinedPreferences[this.state.groupIndexToModify].preferences.find(preference => preference.bidSequence === this.state.bidSequenceToModify)

    const attributes =
      this.props.bidPreferenceClasses.classOptionAttributes || {};
    let parameterValues = [];

    parameterValues = attributes.parameters.filter(parameter => parameter.attribute.attributeId !== UNKNOWN_ATTRIBUTE_ID)
      .map((parameter, index) => ({
        parameterRelation: getParameterRelation(
          this.state.selectedRelation,
          parameter.validRelations
        ),
        parameterId: parameter.parameterId,
        value: getParameterValue(
          this.state.selectedParameterValues,
          attributes.parameters,
          parameter.parameterId,
          this.hiddenParameters.includes(parameter.parameterId)
        ),
        parameterSequence: parameter.sequence
      }));
    // Setting Defaults for undefined Values and for hidden parameters.
    parameterValues.forEach((item, index) => {
      if (
        parameterValues[index].value === undefined ||
        this.hiddenParameters.includes(item.parameterId)
      ) {
        parameterValues[index].value =
          attributes.parameters[index].defaultValue;
      }
    });
    const bidData = {
      bidSessionId: bidSession.currentBid.bidSessionId,
      staffId: bidSession.user.staffId,
      preferenceOptionId: bid.preferenceOptionId,
      preferenceOptionPropertyId: this.state.optionPropertyId,
      parameterValues: parameterValues,
      wish: !!this.state.wish,
      maxnn: this.state.maxnn,
      adminComments: this.state.comment,
      adminName: this.state.adminName,
      bidMode: bidSession.bidMode,
      name: bid.name,
      preferenceClassId: bid.preferenceClassId,
      score: this.state.editCombinedPreferencesScore || bid.score,
      bidAggregateId: bid.bidAggregateId,
      optionLevel: bid.optionLevel,

      groupSequence: bid.groupSequence,
      bidSequence: bid.bidSequence,
    }

    this.props.getPreferencesDescription(bidData).then(response => {
      bidData.description = response.data

      const preferenceIndex = array[this.state.groupIndexToModify].preferences.findIndex(
        pref => pref.bidSequence === this.state.bidSequenceToModify
      );

      array[this.state.groupIndexToModify].preferences.splice(preferenceIndex, 1, bidData);
      this.setState({
        combinedPreferences: array,
        dialogNextState: false,
        classOption: null,
        editPrefFromCombinedPreferenceClassId: null,
        editPrefFromCombinedPreferenceOptionId: null,
        groupIndexToModify: null,
        bidSequenceToModify: null,
        wish: 0,
        disableCancel: true,
        selectedParameterValues: [],
        copyOfEditCombinedPreferences: {},
      });
    })
  }

  render() {
    const { labels } = this.context || {};

    // Use context labels with fallbacks to props
    const BID_TABLE_PROPS = this.props.labels?.BID_TABLE || labels?.BID_TABLE;
    const CLASSES_PROPS = this.props.labels?.CLASSES || labels?.CLASSES;
    const DELETEBIDPREFERENCE_PROPS = this.props.labels?.DELETEBIDPREFERENCE || labels?.DELETEBIDPREFERENCE;
    const DELETEALLBIDPREFERENCE_PROPS = this.props.labels?.DELETEALLBIDPREFERENCE || labels?.DELETEALLBIDPREFERENCE;
    const MAXNN_PROPS = this.props.labels?.MAXNN || labels?.MAXNN;
    const RELATIONS_PROPS = this.props.labels?.RELATIONS || labels?.RELATIONS;
    const DURATION_PROPS = this.props.labels?.DURATION || labels?.DURATION;
    const ADDING_BID_PROPS = this.props.labels?.ADDING_BID || labels?.ADDING_BID;
    const commonLabels_PROPS = this.props.labels?.commonLabels || labels?.commonLabels;
    const SETTINGS_PROPS = this.props.labels?.SETTINGS || labels?.SETTINGS;
    const RESERVE_LINE_PROPS = this.props.labels?.RESERVE_LINE || labels?.RESERVE_LINE;
    const COMBINED_PREFERENCES_PROPS = this.props.labels?.COMBINED_PREFERENCES || labels?.COMBINED_PREFERENCES;
    const IMPORT_PREVIOUS_BID_PROPS = this.props.labels?.IMPORT_PREVIOUS_BID || labels?.IMPORT_PREVIOUS_BID;
    const RESERVE_DOWN_PROPS = this.props.labels?.RESERVE_DOWN || labels?.RESERVE_DOWN;

    const {
      title,
      subtitle,
      listTitle,
      readOnly,
      requestAll
    } = this.props;
    const bidSession = this.props.bidSession ? this.props.bidSession : {};
    const dialogNextState = this.state.dialogNextState;
    const combinedDialogNextState = this.state.combinedDialogNextState;
    const dialogActions = [
      <CancelBackBtn
        key="dialog-cancel"
        className='cancel-button'
        style={{ marginRight: 20 }}
        onClick={() => this.handleRequestClose()}
      >
        {this.props.labels?.BID_TABLE?.DIALOG?.ACTIONS?.[`CANCEL_STEP${this.state.modalScene}`] || 'Cancel'}
      </CancelBackBtn>,
      <SaveApplyNextBtn
        key="dialog-next"
        className={(dialogNextState || combinedDialogNextState) ? 'cancel-button' : 'next-button'}
        onClick={this.setDialogButtonMethod(
          `NEXT_STEP${this.state.modalScene}`
        )}
        disabled={
          this.state.openDialog
            ? this.state.dialogNextState
            : this.state.openCombinedPreferences
              ? this.state.combinedDialogNextState
              : (() => {
                const result = hasEmptyValue(this.state.selectedParameterValues, this.state.preferenceOptionIdToDisableAddButton, this.state.dateErrors);
                return result;
              })()
        }
      >
        {BID_TABLE_PROPS?.DIALOG?.ACTIONS?.[`NEXT_STEP${this.state.modalScene}`] || (Object.keys(this.state.editPreference || {}).length > 0 ? 'Save' : 'Add')}
      </SaveApplyNextBtn>
    ];
    const deleteButtons = [
      <CancelBackBtn
        key="delete-cancel"
        className='logOutBtnNo'
        style={{ marginRight: 8 }}
        onClick={this.handleCloseDeletePreference}
      >
        {DELETEBIDPREFERENCE_PROPS.CANCELBUTTON}
      </CancelBackBtn>,
      <SaveApplyNextBtn
        key="delete-confirm"
        className='logOutBtnYes'
        onClick={this.deletePreferenceAction}
      >
        {DELETEBIDPREFERENCE_PROPS.CONFIRMATIONBUTON}
      </SaveApplyNextBtn>
    ];

    const deleteAllButtons = [
      <CancelBackBtn
        key="delete-all-cancel"
        className='logOutBtnNo'
        style={{ marginRight: 8 }}
        onClick={this.handleCloseDeleteAllPreference}
      >
        {DELETEALLBIDPREFERENCE_PROPS.CANCELBUTTON}
      </CancelBackBtn>,
      <SaveApplyNextBtn
        key="delete-all-confirm"
        className='logOutBtnYes'
        onClick={this.deleteAllPreferenceAction}
      >
        {DELETEALLBIDPREFERENCE_PROPS.CONFIRMATIONBUTON}
      </SaveApplyNextBtn>
    ];

    const commentButtons = [
      <SaveApplyNextBtn
        key="comment-ok"
        className='logOutBtnNo'
        style={{ marginRight: 8 }}
        disabled={this.state.commentok}
        onClick={this.handleCommentOk}
      >
        {'OK'}
      </SaveApplyNextBtn>
    ];

    const actionsForSave = [
      <CancelBackBtn
        key="save-cancel"
        label='Cancel'
        primary
        onTouchTap={this.handleClose}
        id={'cancel-button'}
      />,
      <SaveApplyNextBtn
        key="save-ok"
        label='Ok'
        primary
        keyboardFocused
        onTouchTap={this.handleOk}
        id={'ok-button'}
      />
    ];
    const actionsForInfo = [
      <SaveApplyNextBtn
        label='Ok'
        primary
        keyboardFocused
        onTouchTap={this.handleClose}
        id={'ok-button'}
      />
    ];
    let dialogActionsWeight;
    let dialogMessage;
    let dialogTitle;
    if (
      this.props.bidSession.bidPreferences === undefined ||
      this.props.bidSession.bidPreferences.entries < 1
    ) {
      dialogActionsWeight = actionsForInfo;
      dialogTitle = SETTINGS_PROPS.DIALOG.dialogTitleEmptyBids;
      dialogMessage = SETTINGS_PROPS.DIALOG.dialogMessageEmptyBids;
    } else if (
      bidSession.bidMode !== BidMode.MANUAL.biddingMode &&
      bidSession.bidMode !== BidMode.AUTOMATIC.biddingMode
    ) {
      dialogActionsWeight = actionsForInfo;
      dialogTitle = SETTINGS_PROPS.DIALOG.dialogTitleMode;
      dialogMessage = SETTINGS_PROPS.DIALOG.dialogMessageMode;
    } else if (bidSession.bidMode === BidMode.AUTOMATIC.biddingMode) {
      dialogActionsWeight = actionsForSave;
      dialogTitle = SETTINGS_PROPS.DIALOG.dialogTitleAutomatic;
      dialogMessage = `${SETTINGS_PROPS.DIALOG.dialogMessageAutomatic + BidMode.MANUAL.changedWeight
        }.`;
    } else {
      dialogActionsWeight = actionsForSave;
      dialogTitle = SETTINGS_PROPS.DIALOG.dialogTitleManual;
      dialogMessage = SETTINGS_PROPS.DIALOG.dialogMessageManual;
    }

    const openReserveLineDialogue = () => {
      this.setState({ openReserveLine: false })
    }

    const showCancelMessage = () => {
      this.setState({
        statusDisplay: true,
        statusDisplayText: RESERVE_LINE_PROPS.NOTIFICATION.CANCEL
      });
    }
    const titleStyle = {
      fontSize: '1rem'
    };

    // Use state as the authoritative source for button disabled state
    // After delete all, state is immediately set to false to disable the button
    const menuOptions = [
      {
        key: 'delete-all',
        label: DELETEALLBIDPREFERENCE_PROPS.LABEL,
        func: this.handleDeleteAllPreference,
        disabled: !this.state.hasBidSessionRequests
      },
    ]

    const addGroupeSequence = () => {
      let array = [...this.state.combinedPreferences]
      array.push({ groupSequence: array.length + 1, preferences: [] })
      this.setState({ combinedPreferences: array, groupIndex: array.length - 1 })
    }

    const setGroupIndexToModify = (groupIndex) => {
      if (!this.state.disableCancel) return
      else {
        this.setState({ groupIndex: groupIndex })
      }
    }

    const setCombinedPreferencesName = (e) => {
      const value = e.target.value;

      if (/[^a-zA-Z0-9\s_-]/.test(value)) {
        alert(COMBINED_PREFERENCES_PROPS.NAME_ALERT);
        return;
      }
      if (this.state.combinedPreferences[0].preferences.length === 0) {
        this.setState({ combinedPreferencesName: value, dialogNextState: true });
      } else {
        this.setState({ combinedPreferencesName: value, dialogNextState: false });
      }
    }

    const removeBidFromCombinedPreferences = (groupIndex, bidSequence) => {
      let array = [...this.state.combinedPreferences]

      if (array[groupIndex].preferences[0].employeeBidId) this.setState({ employeeBidId: array[groupIndex].preferences[0].employeeBidId })
      array[groupIndex].preferences = array[groupIndex].preferences
        .filter(preference => preference.bidSequence !== bidSequence)
        .map((preference, index) => {
          preference.bidSequence = index + 1; return preference
        })

      if (array[groupIndex].preferences.length === 0) {
        if (array.length > 1) {
          array.splice(groupIndex, 1)
        }
        array.map((group, index) => {
          group.groupSequence = index + 1;
          group.preferences.map((preference, index) => {

            preference.groupSequence = group.groupSequence
            preference.bidSequence = index + 1
            return preference
          })
          return group
        })
        setGroupIndexToModify(0)
      }
      this.setState({ combinedPreferences: array })
    }

    const removeGroupFromCombinedPreferences = (groupSequenceToRemove) => {
      if (this.state.combinedPreferences[0].preferences[0].employeeBidId) this.setState({ employeeBidId: this.state.combinedPreferences[0].preferences[0].employeeBidId })
      // Filter out the group with the specified `groupSequence`
      const updatedData = this.state.combinedPreferences.filter(group => group.groupSequence !== groupSequenceToRemove);
      // Reassign `groupSequence` values to avoid skipped numbers
      updatedData.forEach((group, index) => {
        group.groupSequence = index + 1; // Reassign sequentially starting from 1

        // Also update `groupSequence` in the group's preferences
        group.preferences.forEach(preference => {
          preference.groupSequence = index + 1;
        });
      });

      this.setState({ combinedPreferences: updatedData });
    }

    const cancelEditCombinedPreference = () => {
      this.setState({
        classOption: null,
        editPrefFromCombinedPreferenceClassId: null,
        editPrefFromCombinedPreferenceOptionId: null,
        groupIndexToModify: null,
        bidSequenceToModify: null,
        wish: 0,
        dialogNextState: true,
        disableCancel: true,
        selectedParameterValues: [],
        isAddButtonDisabled: false,
        copyOfEditCombinedPreferences: {}
      }, () => {
        // Re-check if Delete All should be enabled after closing/cancelling
        this.checkBidSessionRequests();
      });
    }


    // This function checks if the add button should be disabled based on the current state of selected parameter values and date errors
    const disabledAddBidToGroupBtn = () => { // disable add button if there is no selected parameter values or if there is an empty value in the selectedParameterValues array
      let preferenceOptionIdToDisableAddButton = this.state.preferenceOptionIdToDisableAddButton;
      if (
        this.state.selectedParameterValues.length === 0 ||
        hasEmptyValue(this.state.selectedParameterValues, preferenceOptionIdToDisableAddButton, this.state.dateErrors)
      ) {
        return true
      } else return false;
    }


    return (
      <article className='row expanded'>
        <Card style={{ marginTop: 20 }}>
          <CardHead
            key={`card-head-${this.state.hasBidSessionRequests}`}
            title={title}
            subtitle={subtitle}
            headClassName='card-title'
            menuIconType='delete'
            titleStyle={titleStyle}
            hasMenu={true}
            options={menuOptions}
            defaultSettings={this.props.defaultSettings}
            handleOpenImportDialog={this.props.handleOpenImportDialog}
            readOnly={readOnly}
          />
          <div className={`card-footer`}>
            <div className={`card-footer-toggle-container ${this.isWeightMode(bidSession.bidMode) ? '' : 'is-hidden'}`}>
              <p className='card-footer-label'>{commonLabels_PROPS?.WEIGHT_MODE?.WEIGHT}:</p>
              <div className='card-footer-toggle'>
                <DefaultRadioGroup
                  aria-label='weigth'
                  name='weigth'
                  value={this.state.toggled}
                  onChange={this.handleToggle}
                >
                  <FormControlLabel
                    value={false}
                    control={<RadioButton disabled={!this.state.toggled} />}
                    label={commonLabels_PROPS?.WEIGHT_MODE?.BASIC}
                    disabled={readOnly}
                  />
                  <FormControlLabel
                    value={true}
                    control={<RadioButton disabled={this.state.toggled} />}
                    label={commonLabels_PROPS?.WEIGHT_MODE?.ADVANCED}
                    disabled={readOnly}
                  />
                </DefaultRadioGroup>
              </div>
            </div>
            <div className={`card-footer-toggle-container ${this.isWeightMode(bidSession.bidMode) ? '' : 'is-hidden'
              }`}>
              <p className='card-footer-label'> | </p>
            </div>
            <div className={`card-footer-toggle-container ${bidSession?.displayScope ? '' : 'is-hidden'}`}>
              <p className='card-footer-label'>{commonLabels_PROPS?.WEIGHT_MODE?.SCOPE}:</p>
              <div className='card-footer-toggle'>
                <DefaultRadioGroup
                  aria-label='bidscope'
                  name='bidscope'
                  value={this.state.bidScope}
                  onChange={this.handleBidScope}
                >
                  <FormControlLabel
                    value={REGULAR_BID_SCOPE}
                    control={<RadioButton disabled={this.state.bidScope === REGULAR_BID_SCOPE} />}
                    label={commonLabels_PROPS?.WEIGHT_MODE?.REGULAR}
                  />

                  <FormControlLabel
                    value={RESERVE_BID_SCOPE}
                    control={<RadioButton disabled={this.state.bidScope === RESERVE_BID_SCOPE} />}
                    label={commonLabels_PROPS?.WEIGHT_MODE?.RESERVE}
                  />
                </DefaultRadioGroup>
              </div>
            </div>
            <div className={`card-footer-toggle-container ${bidSession?.configureReserveLineType?.entries &&
              bidSession?.configureReserveLineType?.entries.length !== 0 ? '' : 'is-hidden'
              }`}>
              <p className='card-footer-label'> | </p>
              <div
                className={`card-footer-toggle-container`}
              >
                <button className={`reserveline-btn`}
                  onClick={() => { this.setState({ openReserveLine: true }) }} >
                  <p className='reserveline-btn-txt'>
                    {RESERVE_LINE_PROPS.TITLE}
                  </p>
                </button>
              </div>
            </div>
          </div>
          {!readOnly && (
            <CustomFab
              disabled={this.props.readOnly}
              onClick={this.handleTouchTap}
            >
              <AddIcon style={{ color: 'white' }} />
            </CustomFab>
          )}
          {!readOnly && this.state.displayCombinedPreferences && !this.props.hideCombinedFab && (
            <CombinedFab
              readOnly={this.props.readOnly || this.state.bidScope === RESERVE_BID_SCOPE}
              onClick={this.handleCombinedPrefTouchTap}
            >
              <AddIcon style={{ color: 'white' }} />
            </CombinedFab>
          )}
          <Requests
            readOnly={this.props.readOnly}
            title={listTitle}
            preferences={this.props.bidSession.filteredBidPreferences.entries}
            bidSession={bidSession}
            handleDeletePreference={this.handleDeletePreference}
            handleDeleteCombinedPreference={this.handleDeleteCombinedPreference}
            handleMovePreference={this.props.handleMovePreference}
            handleWeightEdit={this.props.handleWeightEdit}
            weightSorting={this.props.weightSorting}
            handleNext={this.handleNext}
            reorderPreferences={this.props.reorderPreferences}
            bidmode={bidSession.bidMode}
            requestAll={requestAll}
            preferenceOptionPropertyId={this.state.optionPropertyId}
            loadingBidTable={this.props.loadingBidTable || this.state.loadingBidTable}
            copyPreference={this.copyPreference}
          />
        </Card>


        {
          this.state.statusDisplay && (
            <Notification
              open={this.state.statusDisplay}
              message={this.state.statusDisplayText}
              closeStatusDisplay={this.closeStatusDisplay}
            />
          )
        }

        <AlertDialog
          alertDialogTitle={dialogTitle}
          openAlertDialog={this.state.changeWeightConfirmation}
          handleOk={this.handleOk}
          handleCancel={this.handleClose}
          okButtonLabel={SETTINGS_PROPS.LANGUAGE.save}
          cancelButtonLabel={SETTINGS_PROPS.LANGUAGE.cancel}
          alertDialogMessage={dialogMessage}
        />

        <AlertDialog
          alertDialogTitle={SETTINGS_PROPS.DIALOG_BID_SCOPE.dialogTitleMode}
          openAlertDialog={this.state.changeBidScopeConfirmation}
          handleOk={this.handleOkBidScopeConfirmation}
          handleCancel={this.handleCloseBidScopeConfirmation}
          okButtonLabel={SETTINGS_PROPS.DIALOG_BID_SCOPE.ok}
          cancelButtonLabel={SETTINGS_PROPS.DIALOG_BID_SCOPE.cancel}
          alertDialogMessage={this.state.bidScope === REGULAR_BID_SCOPE ? SETTINGS_PROPS.DIALOG_BID_SCOPE.dialogMessageReserve :
            SETTINGS_PROPS.DIALOG_BID_SCOPE.dialogMessageRegular}
        />
        <ReserveLine
          open={this.state.openReserveLine}
          title={RESERVE_LINE_PROPS.DIALOG.CARD_TITLE}
          subtitle={RESERVE_LINE_PROPS.DIALOG.CARD_SUBTITLE}
          reorderReserveline={this.props.reorderReserveline}
          openReserveLineDialogue={openReserveLineDialogue}
          data={this.state.reserveLineList}
          isReserveLineTypeSaveFailed={this.props.isReserveLineTypeSaveFailed}
          cancelMessage={showCancelMessage}
          bidSessionId={this.props.bidSession?.currentBid?.bidSessionId}
          staffId={this.props.bidSession?.user?.staffId}
          categoryId={this.props.bidSession?.user?.currentCategory?.categoryId}
        />

        <Dialog
          open={this.state.open || this.state.openCombinedPreferences}
          onClose={this.handleRequestClose}
          style={{ zIndex: 2103 }}
          contentClassName='Add-Bid-Dialog-Height'
          maxWidth={this.state.openCombinedPreferences ? 'lg' : 'md'}
          fullWidth
          scroll="paper"
        >
          <DialogTitle className="dialogTitle">
            <div className='no-margin'>
              <CardHeader
                title={
                  (this.state.modalScene === 1
                    ? BID_TABLE_PROPS?.DIALOG?.CARD_TITLE_STEP1
                    : BID_TABLE_PROPS?.DIALOG?.CARD_TITLE_STEP2) +
                  ' - Bid Scope : ' + this.state.bidScope
                }
                subtitle={
                  this.state.modalScene === 1
                    ? BID_TABLE_PROPS?.DIALOG?.CARD_SUBTITLE_STEP1
                    : BID_TABLE_PROPS?.DIALOG?.CARD_SUBTITLE_STEP2
                }
                className='bid-adding-title'
              />
            </div>
          </DialogTitle>

          <DialogContent className="dialogContent">
            <div>
              {this.state.modalScene < 3 ? (
                <div style={!this.state.openCombinedPreferences ? {} : { display: 'flex', justifyContent: 'space-between' }}>
                  {this.state.loadingBidTable && <CircularLoading big={true} />}
                  <div style={!this.state.openCombinedPreferences ? {} : { width: '55%' }}>
                    <BidClasses
                      bidSession={bidSession}
                      next={this.state.next}
                      handleTabState={this.handleTabState}
                      fetchClassOptionAttributes={this.props.fetchClassOptionAttributes}
                      resetRadio={this.resetRadio}
                      slideIndex={this.state.slideIndex}
                      classOption={this.state.classOption}
                      scrollTop={this.state.scrollTop}
                      optionPropertyId={this.state.optionPropertyId}
                      defaultSelected={this.props.classOption}
                      handleScene={this.handleScene}
                      onRadioSelectionChange={this.handleBack}
                      handlePreferenceOptionIdToCheck={this.handlePreferenceOptionIdToCheck}
                      modalScene={this.state.modalScene}
                      handleCheckboxChange={this.handleCheckboxChange}
                      toggleReserved={this.state.toggleReserved}
                      reserveValue={this.state.optionLevel}
                      handleReserved={this.handleReserved}
                      relation={this.state.selectedRelation}
                      displayScope={bidSession.displayScope}

                      open={this.state.open}
                      openCombinedPreferences={this.state.openCombinedPreferences}
                      editPrefFromCombinedPreferenceOptionId={this.state.editPrefFromCombinedPreferenceOptionId}
                      editPrefFromCombinedPreferenceClassId={this.state.editPrefFromCombinedPreferenceClassId}
                      dateErrorMessages={this.state.dateErrorMessages}
                      validationTimestamp={this.state.validationTimestamp}
                      isCrewGroupDefault={this.props.isCrewGroupDefault}
                      crewGroupId={this.props.crewGroupId}

                    />
                    {this.state.openCombinedPreferences &&
                      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: '', marginTop: '20px' }}>
                        <CancelBackBtn
                          onClick={() => cancelEditCombinedPreference()}
                          disabled={this.state.disableCancel}
                          style={{ marginRight: '10px' }}
                          className='cancel-button'
                        >
                          {COMBINED_PREFERENCES_PROPS.CANCEL}
                        </CancelBackBtn>
                        <SaveApplyNextBtn
                          disabled={this.state.isAddButtonDisabled || disabledAddBidToGroupBtn()}
                          onClick={
                            this.state.groupIndexToModify !== null && this.state.bidSequenceToModify !== null ?
                              () => this.saveEditPrefFromCombined() :
                              () => this.addBidToGroupeSequence(this.props.selectedCombinedPreferences, this.state.groupIndex)
                          }
                        >
                          {(this.state.groupIndexToModify !== null && this.state.bidSequenceToModify !== null) ? COMBINED_PREFERENCES_PROPS.SAVE : COMBINED_PREFERENCES_PROPS.ADD}
                        </SaveApplyNextBtn>
                      </div>

                    }
                  </div>
                  {this.state.openCombinedPreferences &&
                    <CombinedPreferencesWindow
                      addGroupeSequence={addGroupeSequence}
                      combinedPreferences={this.state.combinedPreferences}
                      setGroupIndexToModify={setGroupIndexToModify}
                      groupIndex={this.state.groupIndex}
                      movePreference={this.movePreference}
                      removeBidFromCombinedPreferences={removeBidFromCombinedPreferences}
                      removeGroupFromCombinedPreferences={removeGroupFromCombinedPreferences}
                      editPrefFromCombined={this.editPrefFromCombined}
                      disableCancel={this.state.disableCancel}
                    />
                  }
                </div>

              ) : (
                this.handleScene()
              )}
            </div>
          </DialogContent>
          <DialogActions className="dialogActions">
            <div style={{ display: 'flex', alignItems: 'baseline', width: '500px' }}>
              {this.state.openCombinedPreferences &&
                <span style={{ color: '#3F51B5', marginRight: '20px', width: '25%' }}>{COMBINED_PREFERENCES_PROPS.REQUEST_NAME}</span>
              }
              {this.state.openCombinedPreferences &&
                <CombinedPreferencesTextField
                  onChange={(e) => setCombinedPreferencesName(e)}
                  value={this.state.combinedPreferencesName}
                  inputProps={{ maxLength: 85 }}
                  helperText={this.state.combinedPreferencesName.length > 85 ? `${COMBINED_PREFERENCES_PROPS.TEXT_FIELD}` : `${this.state.combinedPreferencesName.length}/85 characters`}
                  error={this.state.combinedPreferencesName.length > 85}
                />
              }
            </div>
            <div>
              {dialogActions}
            </div>
          </DialogActions>
        </Dialog>

        <Dialog
          modal
          open={this.state.deleteConfirmation}
          onClose={this.handleCloseDeletePreference}
          style={{ zIndex: 9999 }}
        >
          <DialogTitle>{DELETEBIDPREFERENCE_PROPS.CONFIRMATIONTEXT}</DialogTitle>
          <DialogActions>{deleteButtons}</DialogActions>
        </Dialog>

        <Dialog
          modal
          open={this.state.deleteAllConfirmation}
          style={{ zIndex: 9999 }}
        >
          <DialogTitle>{DELETEALLBIDPREFERENCE_PROPS.CONFIRMATIONTEXT}</DialogTitle>
          <DialogActions>{deleteAllButtons}</DialogActions>
        </Dialog>




        <Dialog
          modal={false}
          open={this.state.commentopen}
          style={{ zIndex: 9999 }}
          actions={commentButtons}
          maxWidth={'md'}
          fullWidth
        >
          <DialogTitle><div className='no-margin'><CardHeader title={'Comment Section'} /></div></DialogTitle>
          <DialogContent>
            <DefaultTextField
              id='text-field-controlled'
              multiline
              fullWidth
              value={this.state.comment}
              onChange={this.handleChange}
              style={{ width: '100%' }}
            />
          </DialogContent>
          <DialogActions>{commentButtons}</DialogActions>
        </Dialog>

        <ImportPreferencesDialog
          openDialog={this.props.openImportDialog}
          handleOpen={this.props.handleOpenImportDialog}
          staffId={bidSession?.user?.staffId}
          currentBidSessionId={bidSession?.currentBid?.bidSessionId}
          fetchPreviousBidSession={this.props.fetchPreviousBidSession}
          handleImportPreviousBidPreferences={this.props.handleImportPreviousBidPreferences}
          showNotification={this.props.showNotification}
          categoryId={bidSession?.user?.currentCategory?.categoryId}
          loadingImportPreviousBids={this.props.loadingImportPreviousBids}
          optionPropertyId={this.props.optionPropertyId}
          applicationType={commonLabels_PROPS?.APPLICATION_TYPE}

          okButtonLabel={IMPORT_PREVIOUS_BID_PROPS.IMPORT}
          dialogTitle={IMPORT_PREVIOUS_BID_PROPS.BUTTON}
          dialogMessage={IMPORT_PREVIOUS_BID_PROPS.MESSAGE}
        />
      </article>
    );
  }
}

BidTable.defaultProps = {
  readOnly: false,
  bidSession: {},
  user: {},
  bidPreferenceClasses: {},
  pairingdate: {},
  fetchClassOptionAttributes: () => { },
  savePreference: () => { },
  handleActionPreference: () => { },
  fetchdate: () => { },
  deletePreference: () => { },
  handleMovePreference: () => { },
  reorderPreferences: () => { },
  resetFilter: () => { },
  handleWeightEdit: () => { },
  showNotification: () => { },
  weightSorting: () => { },
  updateWeight: () => { },
  updateWeightAll: () => { },
  updateBidSession: () => { },
  requestAll: false,
  reorderReserveline: () => { },
  bidScope: REGULAR_BID_SCOPE,
  deleteAllPreferences: () => { },
  fetchBidSession: () => { },
  defaultSettings: false,
  saveCombinedPreference: () => { },
  getPreferencesDescription: () => { },
  loadingBidTable: false,
  copyCombinedPreference: () => { },
  fetchPreviousBidSession: () => { },
  handleImportPreviousBidPreferences: () => { },
  loadingImportPreviousBids: false,
  openImportDialog: false,
  handleOpenImportDialog: () => { },
};

BidTable.propTypes = {
  bidSession: PropTypes.object,
  user: PropTypes.object,
  bidPreferenceClasses: PropTypes.object,
  pairingdate: PropTypes.object,
  fetchClassOptionAttributes: PropTypes.func,
  savePreference: PropTypes.func,
  fetchdate: PropTypes.func,
  handleActionPreference: PropTypes.func,
  deletePreference: PropTypes.func,
  handleMovePreference: PropTypes.func,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  listTitle: PropTypes.string.isRequired,
  optionPropertyId: PropTypes.number,
  reorderPreferences: PropTypes.func,
  readOnly: PropTypes.bool,
  resetFilter: PropTypes.func,
  handleWeightEdit: PropTypes.func,
  weightSorting: PropTypes.func,
  showNotification: PropTypes.func,
  updateWeight: PropTypes.func,
  updateWeightAll: PropTypes.func,
  updateBidSession: PropTypes.func,
  requestAll: PropTypes.bool,
  reorderReserveline: PropTypes.func,
  bidScope: PropTypes.string,
  deleteAllPreferences: PropTypes.func,
  fetchBidSession: PropTypes.func,
  defaultSettings: PropTypes.bool,
  saveCombinedPreference: PropTypes.func,
  getPreferencesDescription: PropTypes.func,
  loadingBidTable: PropTypes.bool,
  copyCombinedPreference: PropTypes.func,
  fetchPreviousBidSession: PropTypes.func,
  handleImportPreviousBidPreferences: PropTypes.func,
  loadingImportPreviousBids: PropTypes.bool,
  openImportDialog: PropTypes.bool,
  handleOpenImportDialog: PropTypes.func,
  onPreferencesCleared: PropTypes.func,
  isCrewGroupDefault: PropTypes.bool,
  crewGroupId: PropTypes.string
};

const mapStateToProps = state => ({ ...state.bidPreferenceClasses });

const mapDispatchToProps = dispatch => ({
  fetchClassOptionAttributes: (optionClassId, bidSessionId, openCombinedPreferences) =>
    dispatch(
      actions.default.fetchClassOptionAttributes(optionClassId, bidSessionId, openCombinedPreferences)
    ),

  savePreference: (
    bidSession,
    classOption,
    parameterValues,
    editPreference,
    wish,
    maxnn,
    optionPropertyId,
    adminComments,
    adminName,
    weight,
    bidmode,
    optionLevel,
    scoreApplicable
  ) =>
    dispatch(
      actions.default.savePreference(
        bidSession,
        classOption,
        parameterValues,
        editPreference,
        wish,
        maxnn,
        optionPropertyId,
        adminComments,
        adminName,
        weight,
        bidmode,
        optionLevel,
        scoreApplicable
      )
    ),

  deletePreference: (bidId, employeeBidId, adminComments, adminName) =>
    dispatch(
      actions.default.deletePreference(
        bidId,
        employeeBidId,
        adminComments,
        adminName
      )
    ),
  deleteAllPreferences: (staffId, bidSessionId) => dispatch(actions.default.deleteAllPreferences(staffId, bidSessionId)),
  resetFilter: sessionData =>
    dispatch(opentimesearchactions.resetFilter(sessionData)),
  fetchdate: (pairingName, staffId, bidStart, bidOptionId) =>
    dispatch(actions.default.fetchdate(pairingName, staffId, bidStart, bidOptionId)),
  fetchBidSession: (staffId, bidSessionId, applyStandingBid, defaultBid) =>
    dispatch(
      bidSessionActions.default.fetchBidSession(
        staffId,
        bidSessionId,
        applyStandingBid,
        defaultBid
      )),
  saveCombinedPreference: (combinedPreferences, bidSession, editPreference) =>
    dispatch(actions.default.saveCombinedPreference(combinedPreferences, bidSession, editPreference)),
  getPreferencesDescription: (bid) => dispatch(actions.default.getPreferencesDescription(bid)),
  deleteCombinedPreference: (employeeBidId, groupName, adminComments, adminName, lang) =>
    dispatch(actions.default.deleteCombinedPreference(employeeBidId, groupName, adminComments, adminName, lang)),
  fetchPreviousBidSession: (staffId, categoryId, propertyCode, applicationType, bidSessionId) =>
    dispatch(
      bidSessionActions.default.fetchPreviousBidSession(staffId, categoryId, propertyCode, applicationType, bidSessionId))
});

const ConnectedBidTable = connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(BidTable);

// Forward ref to class instance
const BidTableWithRef = forwardRef((props, ref) => {
  const { labels } = useLanguage();
  return <ConnectedBidTable {...props} labels={labels} forwardedRef={ref} />;
});

export default BidTableWithRef;
